import {
  root,
  $win,
  $doc,
  $html,
  $body,
  inputs
} from './01.constant.mjs';

import {
  debug,
  throttle
} from './02.util.mjs';

import {
  Input,
  Tooltip,
  Darkmode,
  Dialog,
  Loading,
  Form,
  Toast
} from './05.class.mjs';


export class Insurance {
  static Coverage = class {
    static #country = 'li[data-country-code]';
    static #mapPath = 'path[data-country-code]';

    #syncHover(event) {
      const $target = jQuery(event.currentTarget);
      const code = $target.data('countryCode');
      const isActive = event.type === 'mouseenter';

      if ( !code ) return; // 코드 없으면 종료

      // * 패널 내에서 [data-country-code] 국가와 지도 찾음
      // * - 기존에는 문서 전체에서 찾은 후, filter(':visible') 처리했으나
      // * - :visible은 브라우저 리플로우를 유발하여 성능 비용이 높아서 범위를 국한함
      const $panel = $target.closest('div[role=tabpanel]');
      const dataCode = `[data-country-code='${code}']`;
      const $country = $panel.find(`li${dataCode}`);
      const $mapPath = $panel.find(`path${dataCode}`);

      if ( !$country.be() || !$mapPath.be() ) return; // 짝 없으면 종료

      // * toggle [data-hovered] -> 국가/지도 양쪽 모두 동기화
      $country.add($mapPath).toggleDatattrIf('hovered', isActive);

      if ( isActive ) {
        // 1. 먼저 공통 툴팁 클래스로 툴팁 생성 (이때는 지도 래퍼 전체 크기를 기준으로 엉뚱한 곳에 위치함)
        Tooltip.create($mapPath, $country.text().trim());

        // 🌟 2. [페이지 특화 로직] SVG <path> 위에 툴팁이 정확히 뜨도록 위치 강제 보정
        const tooltipId = $mapPath.aria('describedby');
        const $tooltip = jQuery(`#${tooltipId}`);

        if ( $tooltip.be() ) {
          const pathRect = $mapPath.get(0).getBoundingClientRect();
          const wrapperRect = $tooltip.parent().get(0).getBoundingClientRect();
          const th = $tooltip.outerHeight();

          const relTop = pathRect.top - wrapperRect.top;
          const relCenterX = (pathRect.left - wrapperRect.left) + (pathRect.width / 2);

          // 🌟 1. 타겟 Y좌표: 국가의 맨 위(Top)에서 전체 높이의 25%만큼 밑으로 내려온 지점
          const targetY = relTop + (pathRect.height * 0.25);

          // 🌟 2. 툴팁 위치: 꼬리가 targetY에 닿도록 툴팁 높이(th)만큼 위로 끌어올림
          const targetTop = targetY - th;

          $tooltip.removeClass('is-below').addClass('is-above');

          // 3. 위치 덮어쓰기
          $tooltip.css({
            'inset-block-start': `${targetTop}px`,
            'inset-block-end': 'auto',
            'inset-inline-start': `${relCenterX}px`,
            'translate': '-50% 0'
          });
        }
      }
      else Tooltip.remove();
    }

    watch() {
      const self = Insurance.Coverage;
      $body.on('mouseenter mouseleave', `${self.#country}, ${self.#mapPath}`,
        (event) => this.#syncHover(event)
      );
    }
  }

  static ClaimForm = class {
    static #breakpoint = 1000; // * CSS 값과 일치해야 함
    #isWide = undefined; // 현재 컨테이너 너비 상태

    constructor(selectors = '.insurance-claim-forms .sample > details') {
      this.$details = jQuery(selectors);
      // ? first() 없으면 this.$details 각각에 대한 부모 컨테이너 찾으려고 함
      this.$container = this.$details.first().closest('.insurance-claim-forms');
      this.$summary = this.$details.children('summary');
    }

    #handleToggle(event) {
      const $targetDetails = jQuery(event.currentTarget);
      // ? 여기는 '클릭된 요소'의 summary 필요 : 캐싱된 this.$summary 대신 자식 탐색
      const $targetSummary = $targetDetails.children('summary');
      const isOpen = $targetDetails.prop('open');
      $targetSummary.text(
        $targetSummary.data( isOpen ? 'textClose' : 'textOpen')
      );
    }

    #updateDetailsState() {
      const Self = Insurance.ClaimForm;
      const isWideNow = this.$container.width() > Self.#breakpoint;

      if ( isWideNow !== this.#isWide ) {
        this.#isWide = isWideNow;

        this.$details.prop('open', isWideNow);
        this.$summary.hidden(isWideNow); // Wide ? => hidden
      }
    }

    watch() {
      if ( !this.$details.be() || !this.$container.be() ) return;

      this.$details.on('toggle', (event) => this.#handleToggle(event));

      this.#updateDetailsState();// init
      const observer = new ResizeObserver(
        throttle(() => this.#updateDetailsState(), 200)
      );
      observer.observe(this.$container.get(0));
    }
  }
}


export class Support {
  static #steps = 'ol.support-steps';
  static #trigger = 'a[data-step-jump]';

  #handleScroll(event) {
    event.preventDefault();

    const $trigger = jQuery(event.currentTarget);
    const $step = $trigger.closest(Support.#steps).find(
      `li[data-step='${$trigger.data('stepJump')}']`
    );

    // $step.get(0)?.scrollIntoView({behavior: 'smooth', block: 'start'});
    $step.smartScroll({ block: 'center' });
  }

  #bindEvents() {
    $doc.on('click', Support.#trigger, (event) => this.#handleScroll(event));
  }

  watch() {
    this.#bindEvents();
  }
}


export class Faq {
  #selectors = {
    form: 'form[data-faq-search]',
    input: 'input[type="search"]',

    container: '[data-tab]',
    tab: 'button[role="tab"]',
    panel: 'div[role="tabpanel"]',

    item: 'details.details',
    summary: 'summary',
    noResult: '[data-no-search-result]'
  };

  #$form;
  #$input;
  #$container;
  #typingTimer;
  #duration = 200;

  constructor() {
    this.#$form      = jQuery(this.#selectors.form);
    this.#$input     = this.#$form.find(this.#selectors.input);
    this.#$container = jQuery(this.#selectors.container);
  }

  // 텍스트 노드 내 매칭 단어 하이라이팅 (재귀)
  #highlightText(node, regex) {
    if ( node.nodeType === 3 ) {
      regex.lastIndex = 0;
      const match = regex.exec(node.data);

      if ( match ) {
        const mark = document.createElement('mark');
        const matchNode = node.splitText(match.index);

        matchNode.splitText(match[0].length);
        mark.textContent = matchNode.textContent;
        matchNode.parentNode.replaceChild(mark, matchNode);

        return 1;
      }
    }
    else if ( node.nodeType === 1 && node.childNodes && !/(script|style|mark)/i.test(node.tagName) ) {
      if ( node.classList.contains('category') ) return 0;

      for ( let i = 0; i < node.childNodes.length; i++ )
        i += this.#highlightText(node.childNodes[i], regex);
    }
    return 0;
  }

  #removeHighlight($context) {
    $context.find('mark').each((_, elem) => jQuery(elem).contents().unwrap());
    $context.each((_, elem) => elem.normalize());
  }

  #escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  #createFlexiblePattern(term) {
    const chars = term.split('');

    return chars.map((char, index) => {
      const escaped = this.#escapeRegex(char);
      if ( index === chars.length - 1 ) return escaped;

      const nextChar = chars[index + 1];
      const isCurrentKorean = /[가-힣]/.test(char);
      const isNextKorean = /[가-힣]/.test(nextChar);

      if ( isCurrentKorean || isNextKorean ) return escaped + '\\s*';
      return escaped;
    }).join('');
  }

  #filterItems(term) {
    const rawTerm = term.trim();
    const $activePanel = this.#$container.find(`${this.#selectors.panel}:visible`);

    if ( !$activePanel.be() ) return;

    this.#removeHighlight($activePanel);

    // [핵심 변경 1] 공백을 제외한 순수 글자 수 계산
    const pureLength = rawTerm.replace(/\s/g, '').length;

    // [핵심 변경 2] 순수 글자 수가 2글자 미만이면 검색 초기화
    if ( pureLength < 2 ) return this.#resetCurrentPanel();

    // [핵심 변경 3] 토큰 분리 시 글자 수 제한 해제 (1글자도 허용)
    // 공백만 아니면 됨
    const terms = rawTerm.split(/\s+/).filter(t => t.length > 0);

    if ( terms.length === 0 ) return this.#resetCurrentPanel();

    const $items = $activePanel.find(this.#selectors.item);
    const $noResult = $activePanel.find(this.#selectors.noResult);
    let visibleCount = 0;

    const patterns = terms.map(t => this.#createFlexiblePattern(t));
    const highlightRegex = new RegExp(patterns.join('|'), 'gi');
    const checkRegexes = patterns.map(p => new RegExp(p, 'i'));

    $items.each((_, elem) => {
      const $elem = jQuery(elem);
      const textContent = $elem.text();

      const isMatch = checkRegexes.every(regex => textContent.search(regex) > -1);

      if ( isMatch ) {
        visibleCount++;
        $elem.stop(true, true).fadeIn(this.#duration);
        this.#highlightText(elem, highlightRegex);
      }
      else $elem.stop(true, true).fadeOut(this.#duration);
    });

    if ( visibleCount === 0 ) $noResult.stop(true, true).fadeIn(this.#duration);
    else $noResult.hide();
  }

  #resetCurrentPanel() {
    const $activePanel = this.#$container.find(`${this.#selectors.panel}:visible`);
    if ( !$activePanel.be() ) return;

    $activePanel.find(this.#selectors.item).stop(true, true).show();
    $activePanel.find(this.#selectors.noResult).hide();

    this.#removeHighlight($activePanel);
  }

  #bindEvents() {
    this.#$form.on('submit', (event) => {
      event.preventDefault();
      return false;
    });

    this.#$input.on('input', (event) => {
      clearTimeout(this.#typingTimer);
      const term = jQuery(event.currentTarget).value();
      this.#typingTimer = setTimeout(() => this.#filterItems(term), 300);
    });

    this.#$container.on('click', this.#selectors.tab, () => {
      setTimeout(() => {
        const currentTerm = this.#$input.value();
        // [핵심 변경 4] 탭 전환 시에도 공백 제외 2글자 기준 적용
        if ( currentTerm.replace(/\s/g, '').length >= 2 ) this.#filterItems(currentTerm);
        else this.#resetCurrentPanel();
      }, 50);
    });
  }

  watch() {
    if ( !this.#$form.be() || !this.#$input.be() || !this.#$container.be() ) return;
    this.#bindEvents();
  }
}


export class Locations {
  static mapId = '254a7de747a4195db123d84c';
  static config = {
    selector: '.map, .map-detail', // 지도 요소를 찾는 공통 선택자
    pinDark: { // 다크모드 전용 핀 스타일
      background: '#a14f4f',
      borderColor: '#000000',
      glyphColor: '#362c2c',
      scale: 1.0
    }
  };

  #data = {};
  #mapInstances = {};
  #MapClass = null;
  #AdvancedMarkerElement = null;
  #PinElement = null;

  constructor(locationData) { this.#data = locationData; }

// [DOM] 지도 컨테이너 리셋
  #resetMapContainer(slug) {
    // 1. 기존 지도 찾기
    const $oldMap = jQuery(`#map-${slug}, #map-detail-${slug}`);

    if ( !$oldMap.be() ) return null;

    // 2. 기존 속성 백업
    const countryCode = $oldMap.data('countryCode');

    // [수정] data-target-id 속성 값 백업 (이게 없으면 상세 지도 타겟팅 실패)
    const targetId = $oldMap.attr('data-target-id');

    const currentClass = $oldMap.attr('class');
    const currentID = $oldMap.id();

    // 3. 새 요소 생성 (DOM 삽입 전)
    const $newMap = jQuery('<div>', { class: currentClass }).id(currentID);

    if ( countryCode ) $newMap.datattr({ countryCode });

    // [수정] 백업한 targetId를 새 요소에 다시 부여
    if ( targetId ) $newMap.attr('data-target-id', targetId);

    // 4. 기존 자리에 교체
    $oldMap.replaceWith($newMap);

    return $newMap[0];
  }

  // [로직] 지도 로드 및 마커 생성
  #loadMap(slug, code, savedState = null) {
    if ( !this.#MapClass ) return;
    if ( this.#mapInstances[slug] ) return;

    const mapElement = this.#resetMapContainer(slug);
    if ( !mapElement ) return;

    // 1. PHP에서 전달한 타겟 ID 확인
    const targetId = mapElement.dataset.targetId; // data-target-id 값

    const isDark = Darkmode.is();

    const mapOptions = {
      zoom: savedState ? savedState.zoom : 5,
      center: savedState ? savedState.center : { lat: 48.8566, lng: 2.3522 },
      mapId: Locations.mapId,
      colorScheme: isDark ? 'DARK' : 'LIGHT',
      // ▼ [추가] 기본 POI(지도 아이콘) 클릭 비활성화
      clickableIcons: false,
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_LEFT,
      },
      streetViewControl: false,
      fullscreenControl: false,
      keyboardShortcuts: false,
      rotateControl: false,
      zoomControl: true,
      // zoomControlOptions: {
      //   // 원하는 위치 상수로 변경 (예: 우측 중앙)
      //   position: google.maps.ControlPosition.RIGHT_TOP
      // },
    };

    const map = new this.#MapClass(mapElement, mapOptions);
    this.#mapInstances[slug] = map;

    let markersData = [];

    if ( code === 'all' ) {
      Object.values(this.#data).forEach(list => {
        markersData = markersData.concat(list);
      });
    }
    else {
      const dataKey = code.toUpperCase();
      if ( this.#data[dataKey] ) markersData = this.#data[dataKey];
    }

    if ( markersData.length > 0 ) {
      const bounds = new google.maps.LatLngBounds();
      const infoWindow = new google.maps.InfoWindow();
      let validMarkerCount = 0;
      let targetMarker = null;

      markersData.forEach(center => {
        if ( center.lat && center.lng ) {
          const position = {
            lat: parseFloat(center.lat), lng: parseFloat(center.lng)
          };

          let markerContent = null;
          if ( isDark ) {
            const pinView = new this.#PinElement(Locations.config.pinDark);
            markerContent = pinView.element;
          }

          const marker = new this.#AdvancedMarkerElement({
            map: map,
            position: position,
            content: markerContent
          });

          // 2. 타겟 마커 판별
          // HTML의 data-target-id와 마커의 center_id가 일치하면 타겟으로 설정
          if ( targetId && String(center.center_id) === String(targetId) ) {
            targetMarker = marker;
          }

          const buttonGroupHTML = (targetMarker === marker) ? '' : `
            <footer class="button-group justify-end">
              <a href="${center.link}" class="button accent size-cozy more">
                ${window.VIEW_MORE || 'View More'}
                <span class="${window.ICON_CLASS || 'material-symbols-outlined'}" aria-hidden="true">chevron_right</span>
              </a>
            </footer>
          `;

          marker.addListener('gmp-click', () => {
            infoWindow.setContent(`
              <div class="map-info-window">
                <header>
                  <small class="country-name">${center.countryName}</small>
                  <h6 class="title">${center.icon}${center.name}${center.are_pr}</h6>
                </header>
                ${buttonGroupHTML}
              </div>
            `);
            infoWindow.open({ anchor: marker, map: map });
          });

          bounds.extend(position);
          validMarkerCount++;
        }
      });

      if ( !savedState ) {
        // 3. 줌 로직
        if ( targetMarker ) {
          // 타겟이 명확하면(상세 페이지) 무조건 그곳으로 줌
          map.setCenter(targetMarker.position);
          map.setZoom(17);
        }
        else {
          // 타겟이 없으면(리스트 뷰) 바운드 처리
          if ( code === 'all' ) {
            map.setCenter(bounds.getCenter());
            map.setZoom(5);
          }
          else if ( validMarkerCount === 1 ) {
            map.setCenter(bounds.getCenter());
            map.setZoom(7);
          }
          else {
            map.fitBounds(bounds, 100);
            const zoomCheck = google.maps.event.addListener(map, 'idle', () => {
              if ( map.getZoom() > 9 ) map.setZoom(9);
              google.maps.event.removeListener(zoomCheck);
            });
          }
        }
      }
    }
  }
  // [이벤트] 다크모드 변경 핸들러
  #handleDarkModeChange() {
    const $activeTab = jQuery('[role="tab"][aria-selected="true"]');
    let savedState = null, activeSlug = null, activeCode = null;

    if ( $activeTab.be() ) {
      activeSlug = $activeTab.id().replace('tab-', '');
      if ( this.#mapInstances[activeSlug] ) {
        savedState = {
          center: this.#mapInstances[activeSlug].getCenter(),
          zoom: this.#mapInstances[activeSlug].getZoom()
        };
      }
      const $panel = jQuery(`#tabpanel-${activeSlug}`);
      if ( $panel.be() ) {
        const $mapDiv = $panel.find(Locations.config.selector);
        if ( $mapDiv.be() ) {
          activeCode = $mapDiv.data('countryCode') || activeSlug;
        }
      }
    }

    this.#mapInstances = {};
    if ( activeSlug && activeCode ) {
      this.#loadMap(activeSlug, activeCode, savedState);
    }
  }

  // [초기화]
  async watch() {
    while (
      !window.google ||
      !window.google.maps ||
      typeof window.google.maps.importLibrary !== 'function'
    ) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement: Marker, PinElement: Pin }
      = await google.maps.importLibrary('marker');

    this.#MapClass = Map;
    this.#AdvancedMarkerElement = Marker;
    this.#PinElement = Pin;

    // 초기 로드
    let initialSlug = 'all';
    let initialCode = 'all';
    // [수정됨] 해시 또는 URL 경로를 기반으로 초기 탭 결정
    // - 해시가 있으면 해시 우선 (#france)
    // - 해시 없고 URL에 슬러그가 있으면 해당 슬러그의 국가 탭 오픈 (/@/paris-cdg -> FR)
    const hash = window.location.hash.replace('#', '');

    if ( hash && jQuery(`#tab-${hash}`).be() ) {
      initialSlug = hash;
    }
    else if ( window.location.pathname.includes('/@/') ) {
      // URL이 상세 페이지라면, 현재 활성화된(PHP가 active로 렌더링한) 탭을 찾음
      const $activeTab = jQuery('[role="tab"][aria-selected="true"]');
      if ( $activeTab.be() ) {
        initialSlug = $activeTab.id().replace('tab-', '');
      }
    }
    else {
      // 그 외의 경우 기본 탭 (보통 All)
      const $activeTab = jQuery('[role="tab"][aria-selected="true"]');
      if ( $activeTab.be() ) {
        initialSlug = $activeTab.id().replace('tab-', '');
      }
    }

    const $panel = jQuery(`#tabpanel-${initialSlug}`);
    if ( $panel.be() ) {
      const $mapDiv = $panel.find(Locations.config.selector);
      if ( $mapDiv.be() ) {
        initialCode = $mapDiv.data('countryCode') || initialSlug;
        this.#loadMap(initialSlug, initialCode);
      }
    }

    // 탭 변경 이벤트 감지
    $win.on('tab:change', (e, slug) => {
      const targetSlug = slug || 'all';
      const $panel = jQuery(`#tabpanel-${targetSlug}`);
      if ( $panel.be() ) {
        const $mapDiv = $panel.find(Locations.config.selector);
        if ( $mapDiv.be() ) {
          const code = $mapDiv.data('countryCode') || targetSlug;
          this.#loadMap(targetSlug, code);
        }
      }
    });

    // 다크모드 감지
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if ( mutation.attributeName === 'data-is-darkmode' ) this.#handleDarkModeChange();
      });
    });
    observer.observe(root,
      { attributes: true, attributeFilter: ['data-is-darkmode'] }
    );
  }
}


export class Book {
  constructor() {
    this.lang = root.lang || 'en';
    this.isLoadingVehicles = false; // [NEW] AJAX 무한 루프 방지용 락
  }

  #initSummary() {
    if ( !window.BOOK_ITINERARY ) return;
    const data = window.BOOK_ITINERARY;

    jQuery('#pickup-center').value(data.pickup_center);
    jQuery('#return-center').value(data.return_center);
    jQuery('#pickup-date').datattr({ datetimerSelected: data.pickup_date }).value(data.pickup_date_text);
    jQuery('#return-date').datattr({ datetimerSelected: data.return_date }).value(data.return_date_text);
    jQuery('output[name="duration"]').text(data.duration);
  }

  async #loadVehicles() {
    // 1. [해결] 통신 중복 및 무한 루프 원천 차단
    if ( this.isLoadingVehicles ) return;
    this.isLoadingVehicles = true;

    const sort = jQuery('#sort-vehicles').value() || 'price';
    const $vehicles = jQuery('.vehicles');

    $vehicles.addClass('activate-mod');
    Loading.show(); // [NEW] 로딩 표시

    try {
      const html = await jQuery.ajax({
        url: '/js/ajax/@page/book-vehicles.php',
        method: 'GET',
        data: { sort, lng: this.lang }, // [해결] 푸조 이슈 방지를 위해 언어값 명시적 전달
        dataType: 'html'
      });

      $vehicles.html(html).removeClass('activate-mod');

      // 2. [해결] 무한 루프를 유발하는 trigger('change') 대신 수동으로 속성 부여
      const $sortSelect = $vehicles.find('#sort-vehicles');
      if ( $sortSelect.be() ) {
        $sortSelect.toggleDatattrIf('hasValue', !!$sortSelect.value());
      }
    }
    catch (error) {
      Dialog.error('Failed to load vehicles.');
      $vehicles.removeClass('activate-mod');
    }
    finally {
      // 성공이든 실패든 무조건 락을 해제하고 로딩 창 닫기
      this.isLoadingVehicles = false;
      Loading.hide();
    }
  }

  // 차량 선택 (2단계 -> 3단계 전환)
  async #selectVehicle(event) {
    event.preventDefault(); // 기본 submit 방지

    const $btn = jQuery(event.currentTarget);
    const $article = $btn.closest('article');
    const carId = $article.data('carId');
    const acoId = $article.data('acoId') || 0;

    if ( !carId ) return;

    $btn.disable();
    Loading.show();

    try {
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/book-session-vehicle.php',
        method: 'POST',
        dataType: 'json',
        data: { // 🌟 [수정] 서버로 전송할 payload에 aco_id를 추가합니다.
          car_id: carId,
          aco_id: acoId
        }
      });

      if ( response.success ) {
        // 3단계 Options 페이지로 리다이렉트
        window.location.href = `/${this.lang.toLowerCase()}/book/options`;
      }
      else {
        Dialog.error(response.message);
        $btn.enable();
      }
    }
    catch (error) {
      Dialog.error('Failed to select vehicle.');
      $btn.enable();
    }
    finally {
      Loading.hide();
    }
  }

  async #modify(event) {
    event.preventDefault();

    const $btn = jQuery(event.currentTarget);
    const $inputs = jQuery('#pickup-center, #return-center, #pickup-date, #return-date');

    // 🌟 [수정] warning 클래스 대신 data-editMode 속성으로 수정 모드 상태 추적
    const isEditing = $btn.data('editMode');

    // [Case A] 수정 모드 진입
    if ( !isEditing ) {
      const beforeChangeText = $btn.data('buttonTextBeforeChange');
      if ( beforeChangeText ) {
        this.#updateButtonText($btn, beforeChangeText);
      }

      $btn.data('editMode', true);
      $inputs.readonly(false);
      jQuery('.vehicles').addClass('activate-mod');

      // 입력값 변경 감지 리스너 추가
      this.#watchInputChanges($btn, $inputs);
    }
    // [Case B] 취소 또는 수정 완료
    else {
      const pickupCenter = jQuery('#pickup-center').value();
      const returnCenter = jQuery('#return-center').value();
      const pickupDate = jQuery('#pickup-date').data('datetimerSelected');
      const returnDate = jQuery('#return-date').data('datetimerSelected');

      // 현재값과 초기값 비교하여 변경 여부 판단
      const orig = window.BOOK_ITINERARY;
      const hasChanges = pickupCenter !== ( orig?.pickup_center || '' ) ||
        returnCenter !== ( orig?.return_center || '' ) ||
        pickupDate !== ( orig?.pickup_date || '' ) ||
        returnDate !== ( orig?.return_date || '' );

      // 🌟 [NEW] 변경이 없으면 (취소 버튼): 수정 모드 해제 및 UI 원복
      if ( !hasChanges ) {
        this.#resetModifyButton($btn);
        $inputs.readonly(true);
        jQuery('.vehicles').removeClass('activate-mod');
        return;
      }

      // 변경이 있으면: 저장 처리 계속
      const duration = parseInt(jQuery('output[name="duration"]').text(), 10 ) || 0;
      if ( !pickupCenter || !returnCenter || !pickupDate || !returnDate || !duration ) return;

      $btn.disable();
      $inputs.readonly(true);
      Loading.show();

      try {
        const response = await jQuery.ajax({
          url: '/js/ajax/@page/book-session.php',
          method: 'POST',
          dataType: 'json',
          data: {
            pickup_center: pickupCenter,
            return_center: returnCenter,
            pickup_date: pickupDate,
            return_date: returnDate,
            duration: duration
          }
        });

        if ( response.success ) {
          window.BOOK_ITINERARY.pickup_center = pickupCenter;
          window.BOOK_ITINERARY.return_center = returnCenter;
          window.BOOK_ITINERARY.pickup_date = pickupDate;
          window.BOOK_ITINERARY.return_date = returnDate;
          window.BOOK_ITINERARY.duration = duration;

          this.#resetModifyButton( $btn );
          $btn.enable();
          await this.#loadVehicles();
        }
        else {
          Dialog.error(response.message);
          $inputs.readonly(false);
          $btn.enable();
        }
      }
      catch ( error ) {
        Dialog.error( 'Failed to save session.' );
        $inputs.readonly(false);
        $btn.enable();
      }
      finally {
        Loading.hide();
      }
    }
  }

  // 🌟 [수정] 아이콘 위치를 초기에 한 번만 감지하여 저장
  #detectAndStoreIconPosition($btn) {
    if ( $btn.data('iconPosition') ) return; // 이미 저장됐으면 스킵

    const $icon = $btn.find('span');
    if ( $icon.be(false) ) {
      $btn.data('iconPosition', 'none');
      return;
    }

    let position = 'start'; // 기본값

    // 버튼 내부의 모든 노드(텍스트 노드 포함)를 순회하며 순서 파악
    $btn.contents().each(function() {
      // 1. 공백이 아닌 실제 텍스트 노드를 먼저 만난 경우
      if (this.nodeType === 3 && this.nodeValue.trim() !== '') {
        position = 'end'; // 텍스트가 먼저 나왔으므로 아이콘은 뒤(end)에 있음
        return false; // 반복문 종료 (break)
      }

      // 2. <span> 태그를 먼저 만난 경우
      if (this.nodeType === 1 && this.tagName.toLowerCase() === 'span') {
        position = 'start'; // 아이콘이 먼저 나왔으므로 start
        return false; // 반복문 종료 (break)
      }
    });

    $btn.data('iconPosition', position);
  }

  // 🌟 [수정] 버튼 텍스트 업데이트 (저장된 아이콘 위치 사용)
  #updateButtonText($btn, newText) {
    // 아이콘 위치를 처음으로 감지 및 저장
    this.#detectAndStoreIconPosition($btn);

    const $icon = $btn.find('span');
    if (!$icon.length) {
      $btn.text(newText);
      return;
    }

    const iconHTML = $icon[0].outerHTML;
    const position = $btn.data('iconPosition');

    // 저장된 위치 정보로 일관되게 배열
    if ( position === 'start' ) $btn.html(iconHTML + newText);
    else $btn.html(newText + iconHTML);
  }

  // 🌟 [수정] 입력값 변경 감지 메서드 - warning 클래스를 변경 감지 시에만 추가
  #watchInputChanges($btn, $inputs) {
    const orig = window.BOOK_ITINERARY;
    const originalText = $btn.data('buttonTextOriginal'); // "Modify"
    const beforeChangeText = $btn.data('buttonTextBeforeChange'); // "Cancel"

    // 기존 이벤트 리스너 제거 (중복 바인딩 방지)
    $inputs.off('change.modifyWatch');

    $inputs.on('change.modifyWatch', () => {
      const pickupCenter = jQuery('#pickup-center').value();
      const returnCenter = jQuery('#return-center').value();
      const pickupDate = jQuery('#pickup-date').data('datetimerSelected');
      const returnDate = jQuery('#return-date').data('datetimerSelected');

      // 현재값과 초기값 비교
      const hasChanges =
        pickupCenter !== ( orig?.pickup_center || '' ) ||
        returnCenter !== ( orig?.return_center || '' ) ||
        pickupDate !== ( orig?.pickup_date || '' ) ||
        returnDate !== ( orig?.return_date || '' );

      // 변경 있으면 "Modify" 텍스트 + warning 클래스, 없으면 초기 텍스트 + secondary 클래스
      const targetText = hasChanges ? originalText : beforeChangeText;
      const currentText = $btn.text().trim();

      if ( currentText !== targetText ) {
        this.#updateButtonText($btn, targetText);
      }

      // 🌟 [NEW] warning/secondary 클래스를 변경 여부에 따라 동적으로 관리
      if ( hasChanges ) {
        $btn.removeClass('secondary').addClass('warning');
      }
      else {
        $btn.removeClass('warning').addClass('secondary');
      }
    } );
  }

  // 🌟 [수정] 버튼을 초기 상태로 복원하는 메서드
  #resetModifyButton($btn) {
    const originalText = $btn.data('buttonTextOriginal');

    if ( originalText ) this.#updateButtonText($btn, originalText);

    $btn.removeClass('warning').addClass('secondary');
    $btn.data('editMode', false); // 🌟 [NEW] 수정 모드 해제
    jQuery('.vehicles').removeClass('activate-mod');

    // 이벤트 리스너 제거
    const $inputs = jQuery('#pickup-center, #return-center, #pickup-date, #return-date');
    $inputs.off('change.modifyWatch');
  }

  // 3단계 옵션 선택 완료 및 4단계 전환
  async #selectOptions(event) {
    event.preventDefault(); // 폼 기본 제출 방지

    const $btn = jQuery(event.currentTarget);
    const $form = jQuery('#book-options'); // 3단계 폼 랩퍼

    // 기존 코드: const formData = $form.serialize();
    // 변경 코드: 요약 영역의 인풋(체크박스)도 포함하여 직렬화
    const formData = $form.add('.summary :input').serialize();

    $btn.disable();
    Loading.show();

    try {
      // 서버에 데이터 전송 및 세션 저장 요청
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/book-session-options.php', // [NEW] 3단계 전용 AJAX 파일
        method: 'POST',
        data: formData,
        dataType: 'json'
      });

      if ( response.success ) {
        // 성공 시 4단계 Details 페이지로 리다이렉트
        window.location.href = `/${this.lang.toLowerCase()}/book/details`;
      }
      else {
        Dialog.error(response.message || 'Failed to process options.');
        $btn.enable();
      }
    }
    catch (error) {
      Dialog.error('Network error occurred while saving options.');
      $btn.enable();
    }
    finally {
      Loading.hide();
    }
  }

  // 🌟 [NEW] 4단계 최종 폼 제출 (Submit) 핸들러
  async #submitBook(event) {
    event.preventDefault();

    const $form = jQuery(event.currentTarget);
    const $btn = $form.find('button[type="submit"]');

    // 🌟 [최적화 1] Input 클래스의 통합 검증 API 호출!
    if ( typeof Input !== 'undefined' && !Input.validateForm($form) ) return;

    $btn.disable();
    Loading.show();

    try {
      // 🌟 [최적화 2] Form 클래스의 헬퍼로 FormData 추출
      const formData = typeof Form !== 'undefined' && Form.fetchFormData
        ? Form.fetchFormData($form)
        : new FormData($form[0]);

      // 💡 [도우미 함수] data()로 읽은 값에 콤마가 있으면 제거 후 float 변환, 없으면 0 반환
      const parseDataNum = (val) => {
        if (!val) return 0;
        if (typeof val === 'number') return val;
        return parseFloat(String(val).replace(/,/g, '')) || 0;
      };

      // 1. 결제 세부 내역 추출
      const breakdowns = [];
      jQuery('li[data-advance-breakdown-amount]').each(function() {
        const $li = jQuery(this);

        // jQuery data()로 깔끔하게 추출 (케밥 케이스 -> 카멜 케이스 자동 변환)
        const attrAmount = parseDataNum($li.data('advanceBreakdownAmount'));
        const attrCurrency = ($li.data('advanceBreakdownAmountCurrency') || '').trim();
        const isEur = attrCurrency.toUpperCase() === 'EUR';

        const attrConvertedAmount = parseDataNum($li.data('advanceBreakdownAmountConverted'));
        const attrConvertedCurrency = ($li.data('advanceBreakdownAmountConvertedCurrency') || '').trim();
        const attrFxRate = parseDataNum($li.data('advanceBreakdownAmountFxRate'));

        let amountEur = 0;
        let amountFxd = null;
        let amountCur = null;

        if ( isEur ) {
          amountEur = attrAmount;
          if ( attrConvertedCurrency && attrFxRate !== 0 ) {
            amountCur = attrConvertedCurrency;
            amountFxd = attrConvertedAmount || null;
          }
        }
        else {
          amountFxd = attrAmount || null;
          amountCur = attrCurrency || null;
          amountEur = attrConvertedAmount;
        }

        breakdowns.push({
          item_name: $li.find('[data-advance-breakdown-item]').text().trim(),
          amount_eur: amountEur,
          amount_fxd: amountFxd,
          amount_CUR: amountCur,
          rate_fx: attrFxRate || null,

          // 하위 호환성
          amount: amountFxd,
          currency: amountCur || attrCurrency
        });
      });
      formData.append('payment_breakdowns', JSON.stringify(breakdowns));

      // 2. HTML data-* 속성 데이터 스크래핑
      const $advTitle = jQuery('.advance .pay-title');
      const $advSubtotal = jQuery('li.pay-subtotal');
      const $balTitle = jQuery('.balance .pay-title');
      const $ddayFieldset = jQuery('fieldset[data-dday-mod]');

      // 전역 가격 정보
      const cpEur = parseDataNum(jQuery('[data-price-final-eur]').data('priceFinalEur'));
      formData.append('price_final_eur', cpEur);

      // Advance 정보
      formData.append('advance_eur', parseDataNum($advTitle.data('advanceEur')));
      formData.append('advance_fxd', $advSubtotal.data('advanceFxd') || '');
      formData.append('advance_cur', $advSubtotal.data('advanceCur') || '');
      formData.append('advance_rate_fx', parseDataNum($advTitle.data('advanceRateFx')) || '');
      formData.append('advance_min_booking_fee_cur', $advTitle.data('advanceMinBookingFeeCur') || '');

      // 🌟 [새로 추가] 선금 결제 안내 텍스트
      formData.append('advance_how_to_pay', $advTitle.data('advanceHowToPay') || '');

      // 🌟 [새로 추가] 예약 수수료/안내 노트 텍스트 긁어오기
      formData.append('booking_fee_note', $advTitle.data('bookingFeeNote') || '');

      // Balance 정보
      formData.append('balance_eur', parseDataNum($balTitle.data('balanceEur')));
      formData.append('balance_min_booking_fee_cur', $balTitle.data('balanceMinBookingFeeCur') || '');

      // 🌟 [새로 추가] 현지 지불 결제 안내 및 변경 후 텍스트
      formData.append('balance_how_to_pay', $balTitle.data('balanceHowToPay') || '');
      formData.append('balance_how_to_pay_after_payday', $balTitle.data('balanceHowToPayAfterPayday') || '');

      // D-Day 정보
      formData.append('dday_mod', $ddayFieldset.data('ddayMod') || '');
      formData.append('dday_cxl', $ddayFieldset.data('ddayCxl') || '');
      formData.append('dday_res', $ddayFieldset.data('ddayRes') || '');

      // Loyalty 정보
      const loyalGift = jQuery('[data-loyalty-gift]').text().trim();
      const loyalDiscountEur = parseDataNum(jQuery('[data-discount-eur-if-loyal]').data('discountEurIfLoyal'));

      if ( loyalGift ) formData.append('loyal_gift', loyalGift);
      if ( loyalDiscountEur ) formData.append('loyal_discount_eur', loyalDiscountEur);

      // 🌟 [추가] 단골 고객 혜택 (Loyalty Benefits) HTML 스크래핑
      const loyaltyBenefits = [];

      // ul[data-loyalty] 안의 모든 li를 순회합니다.
      $doc.find('ul[data-loyalty] li').each(function() {
        const $li = jQuery(this);

        // 텍스트 노드나 속성값 등 어디에 값이 있든 안전하게 긁어옵니다.
        const benefit = $li.data('loyaltyBenefit') || '';
        const amount = $li.data('loyaltyBenefitAmount') || '';

        if ( benefit ) loyaltyBenefits.push( {benefit, amount } );
      });

      // 긁어모은 배열을 JSON 문자열로 변환하여 폼 데이터에 탑재
      formData.append('loyal_benefits_list', JSON.stringify(loyaltyBenefits));

      // 3. 백엔드 전송
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/book-register.php',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json'
      });

      // 4. 결과 분기 처리
      if ( response.result === 'success' || response.success ) {
        window.location.href = `/${this.lang.toLowerCase()}/book/complete`;
      }
      else {
        if ( response.reason === 'REQUIRE_LOGIN' ) {
          Dialog.alertSimple(response.message);
        }
        else Dialog.error(response.message);

        $btn.enable();
      }
    }
    catch ( error ) {
      // 🌟 서버가 내뱉은 진짜 에러 원문을 화면에 다이얼로그로 출력
      const realError = error.responseText || error.statusText || 'Unknown Network Error';
      Dialog.error(`Server communication failed: ${realError}`);

      $btn.enable();
    }
    finally {
      Loading.hide();
    }
  }

  #prev(event) {
    event.preventDefault();

    // 1. PHP에서 넘겨준 스텝 슬러그 배열 활용 (안전망으로 기본 배열 폴백 추가)
    const steps = window.BOOK_STEPS || ['book', 'vehicle', 'options', 'details', 'complete'];

    // 2. 현재 URL 파싱 (끝 슬래시 제거)
    const path = window.location.pathname.replace(/\/$/, '');
    const lang = this.lang.toLowerCase();

    // 3. 경로에서 마지막 세그먼트(슬러그)만 추출
    const currentSlug = path.split('/').pop();
    const currentIndex = steps.indexOf(currentSlug);

    // 4. 이전 스텝 슬러그 계산
    // (현재 슬러그가 배열에 없거나 1단계면 안전하게 1단계로 폴백)
    const prevSlug = currentIndex > 0 ? steps[currentIndex - 1] : steps[0];

    // 5. 최종 이동할 URL 조합 및 명시적 리다이렉트
    const prevUrl = prevSlug === steps[0]
      ? `/${lang}/book`  : `/${lang}/book/${prevSlug}`;

    window.location.href = prevUrl;
  }

  // Next 버튼 클릭 시 동작 (1단계 1.index.php 전용)
  async #next(event) {
    event.preventDefault();

    const $btn = jQuery(event.currentTarget);

    if ( jQuery('#pickup-center').be() ) {
      const pickupCenter = jQuery('#pickup-center').value();
      const returnCenter = jQuery('#return-center').value();
      const pickupDate = jQuery('#pickup-date').data('datetimerSelected');
      const returnDate = jQuery('#return-date').data('datetimerSelected');
      const duration = parseInt(jQuery('output[name="duration"]').text(), 10) || 0;

      // [수정] Text 추출 및 검증 조건 제거 (백엔드 book-session.php 변경에 맞춤)
      if ( !pickupCenter || !returnCenter || !pickupDate || !returnDate || !duration ) {
        return;
      }

      $btn.disable();

      try {
        const response = await jQuery.ajax({
          url: '/js/ajax/@page/book-session.php',
          method: 'POST',
          dataType: 'json',
          data: {
            pickup_center: pickupCenter,
            return_center: returnCenter,
            pickup_date: pickupDate,
            return_date: returnDate,
            duration: duration
          }
        });

        if ( response.success ) {
          window.location.href = `/${this.lang.toLowerCase()}/book/vehicle`;
        }
        else {
          Dialog.error(response.message);
          $btn.enable();
        }
      }
      catch (error) {
        Dialog.error('Failed to save session.');
        $btn.enable();
      }
    }
  }

  #cascade() {
    const cascade = [
      { trigger: '#pickup-center', target: '#return-center' },
      { trigger: '#return-center', target: '#pickup-date' },
      { trigger: '#pickup-date', target: '#return-date' },
      { trigger: '#return-date', target: 'button[data-book-action="next"], button[data-book-action="modify"]' }
    ];

    cascade.forEach(({ trigger, target }) => {
      $doc.on('change', trigger, (e) => {
        const $trigger = jQuery(e.currentTarget);
        const $target = jQuery(target);
        const val = $trigger.value();

        // 1. 하위 폼 무조건 초기화 (Cascade Reset)
        if ( $target.is('button') ) $target.disable();
        else $target.removeDatattr('datetimerSelected').value('').disable();

        if ( trigger === '#return-date' && !val ) {
          jQuery('output[name="duration"]').text('');
        }

        if ( val ) {
          $target.enable();

          // [NEW] 센터 팝업 알림 체크 및 다이얼로그 호출
          if ( trigger === '#pickup-center' || trigger === '#return-center' ) {
            // [수정] 현재 trigger 요소가 readonly 상태가 아닐 때(사용자가 직접 수정 중일 때)만 팝업 실행
            if ( $trigger.attr('readonly') === undefined ) {
              const isPickup = trigger === '#pickup-center';
              const type = isPickup ? 'pickup' : 'return';
              const popupData = window.BOOK_CENTERS?.[val]?.popup?.[type];

              if ( popupData && popupData.content ) {
                let doShowPopup = true;
                if ( !isPickup ) {
                  const pickupVal = jQuery('#pickup-center').value();
                  const hasPickupPopup = window.BOOK_CENTERS?.[val]?.popup?.pickup;
                  if ( val === pickupVal && hasPickupPopup ) doShowPopup = false;
                }
                if ( doShowPopup ) Dialog.alert(popupData.content, popupData.title);
              }
            }
          }

          // ---- 픽업 센터 선택 시 ----
          if ( trigger === '#pickup-center' ) {
            jQuery('#return-center option').prop('disabled', false);
            const centerData = window.BOOK_CENTERS?.[val];

            if ( centerData ) {
              let finalFrom = centerData.from;
              let finalTill = window.BOOK_MAX_DELIVERY_TILL;

              if ( centerData.open_from && centerData.open_from > finalFrom ) finalFrom = centerData.open_from;
              if ( centerData.open_till && centerData.open_till < finalTill ) finalTill = centerData.open_till;

              const [ pY, pM, pD ] = finalFrom.split('-');
              const durationMin = window.BOOK_YEARS?.[pY]?.duration_min ? parseInt(window.BOOK_YEARS[pY].duration_min, 10) : 15;

              const minRetObj = new Date(parseInt(pY, 10), parseInt(pM, 10) - 1, parseInt(pD, 10));
              minRetObj.setDate(minRetObj.getDate() + durationMin - 1);

              const retY = minRetObj.getFullYear();
              const retM = String(minRetObj.getMonth() + 1).padStart(2, '0');
              const retD = String(minRetObj.getDate()).padStart(2, '0');
              const earliestReturnDate = `${retY}-${retM}-${retD}`;

              jQuery('#return-center option').each(function() {
                const retId = this.value;
                if ( !retId ) return;
                const retData = window.BOOK_CENTERS[retId];
                if ( retData && retData.open_till && retData.open_till < earliestReturnDate ) {
                  jQuery(this).prop('disabled', true);
                }
              });

              jQuery('#pickup-date').datattr({
                datetimerFrom: finalFrom,
                datetimerTill: finalTill,
                datetimerDisabled: centerData.pickup.disabled.join(', '),
                datetimerDisabledDow: centerData.pickup.disabledDow
              });
            }
          }

          // ---- 픽업 날짜 선택 시 ----
          if ( trigger === '#pickup-date' ) {
            const realDate = $trigger.data('datetimerSelected');

            if ( realDate ) {
              const [ yearStr, monthStr, dayStr ] = realDate.split('-');
              const year = parseInt(yearStr, 10);
              const month = parseInt(monthStr, 10) - 1;
              const day = parseInt(dayStr, 10);

              const durationMin = window.BOOK_YEARS?.[yearStr]?.duration_min ? parseInt(window.BOOK_YEARS[yearStr].duration_min, 10) : 15;

              const minReturnDateObj = new Date(year, month, day);
              minReturnDateObj.setDate(minReturnDateObj.getDate() + durationMin - 1);

              const retY = minReturnDateObj.getFullYear();
              const retM = String(minReturnDateObj.getMonth() + 1).padStart(2, '0');
              const retD = String(minReturnDateObj.getDate()).padStart(2, '0');
              const minReturnDate = `${retY}-${retM}-${retD}`;

              const pickupCenterVal = jQuery('#pickup-center').value();
              const pickupCenterData = window.BOOK_CENTERS?.[pickupCenterVal];
              const durationMax = pickupCenterData?.duration_max || 355;

              const maxReturnDateObj = new Date(year, month, day);
              maxReturnDateObj.setDate(maxReturnDateObj.getDate() + durationMax - 1);

              const maxRetY = maxReturnDateObj.getFullYear();
              const maxRetM = String(maxReturnDateObj.getMonth() + 1).padStart(2, '0');
              const maxRetD = String(maxReturnDateObj.getDate()).padStart(2, '0');
              const maxReturnDate = `${maxRetY}-${maxRetM}-${maxRetD}`;

              const returnCenterVal = jQuery('#return-center').value();
              const returnCenterData = window.BOOK_CENTERS?.[returnCenterVal];

              let finalFrom = minReturnDate;
              let finalTill = maxReturnDate;

              if ( returnCenterData ) {
                if ( returnCenterData.open_from && returnCenterData.open_from > finalFrom ) finalFrom = returnCenterData.open_from;
                if ( returnCenterData.open_till && returnCenterData.open_till < finalTill ) finalTill = returnCenterData.open_till;
              }

              jQuery('#return-date').datattr({
                datetimerFrom: finalFrom,
                datetimerTill: finalTill,
                datetimerDisabled: returnCenterData ? returnCenterData.return.disabled.join(', ') : '',
                datetimerDisabledDow: returnCenterData ? returnCenterData.return.disabledDow : ''
              });
            }
          }

          // ---- 리턴 날짜 선택 시 ----
          if ( trigger === '#return-date' ) {
            const pickupRealDate = jQuery('#pickup-date').data('datetimerSelected');
            const returnRealDate = $trigger.data('datetimerSelected');

            if ( pickupRealDate && returnRealDate ) {
              const [ pY, pM, pD ] = pickupRealDate.split('-');
              const utcPickup = Date.UTC(parseInt(pY, 10), parseInt(pM, 10) - 1, parseInt(pD, 10));

              const [ rY, rM, rD ] = returnRealDate.split('-');
              const utcReturn = Date.UTC(parseInt(rY, 10), parseInt(rM, 10) - 1, parseInt(rD, 10));

              const diffDays = Math.floor((utcReturn - utcPickup) / (1000 * 60 * 60 * 24)) + 1;

              jQuery('output[name="duration"]').countTo(diffDays);
            }
          }
        }
      });
    });
  }

  // [NEW] 플랜 옵션 선택 시 테이블 열(Column) 하이라이트 처리
  #planSelect(event) {
    const $radio = jQuery(event.currentTarget);
    const $table = $radio.closest('table.plan'); // 테이블 영역 찾기
    const $cols = $table.find('colgroup col');   // col 그룹 찾기

    // 라디오 버튼이 속한 td가 테이블의 몇 번째 칸(Index)인지 파악
    const cellIndex = $radio.closest('td').index();

    // 이전에 선택된 강조 클래스 모두 초기화
    $cols.removeClass('col-selected col-plan-selected');

    // 사용자가 체크한 경우에만 클래스 부여 (라디오 버튼이므로 사실상 항상 체크됨)
    if ( $radio.prop('checked') ) {
      // th(제목행 등)를 포함한 인덱스 보정 처리 (일반적으로 td 인덱스 + th 인덱스 개수)
      // 현재 플랜 테이블 구조상, Standard는 3번째 <col>(index: 3), Plan은 4번째 <col>(index: 4)과 매칭됨.
      const targetColIndex = cellIndex + 2;
      const $targetCol = $cols.eq(targetColIndex);

      $targetCol.addClass('col-selected');

      // 'plan-radio' 래퍼 안에 있는 라디오(즉, 플랜 옵션)를 선택한 경우
      if ( $radio.closest('.plan-radio').be() ) {
        $targetCol.addClass('col-plan-selected');
      }
    }
  }

  // [NEW] 액세서리 수량 변경 시 아웃풋(개수, 합계) 업데이트
  #updateAccessory(event) {
    const $input = jQuery(event.currentTarget);
    const $card = $input.closest('.card');
    if ( !$card.length ) return;

    // 1. 단가 및 수량 파악
    const qty = $input.is('[type="checkbox"]')
      ? ($input.checked() ? 1 : 0)
      : (parseInt($input.value(), 10) || 0);

    // 🌟 [NEW] 수량이 0보다 크면 'selected' 추가, 아니면 제거 (1줄 컷!)
    $card.toggleClass('selected', qty > 0);

    // 2. 수량(Quantity) 텍스트 업데이트
    const $outQty = $card.find('[data-quantity]');
    if ( $outQty.length ) $outQty.text(qty);

    // 3. 합계(Total) 텍스트 업데이트 (PHP에서 미리 구워둔 데이터 꺼내 쓰기!)
    const $outTotal = $card.find('[data-price-total]');
    if ( $outTotal.length ) {
      const pricesArr = $card.data('prices');

      if ( pricesArr && pricesArr[qty] !== undefined ) {
        $outTotal.html(pricesArr[qty]);
      }
    }
  }

  // 🌟 로열티 혜택(연료) 여부에 따른 액세서리 자동 제어 로직
  #handleLoyaltyFuel(event) {
    const $loyaltyCb = jQuery(event.currentTarget);
    const $fuelAcc = jQuery('[data-accessory-fuel]');

    if ( $fuelAcc.be('not') ) return;

    if ( $loyaltyCb.checked() ) {
      const benefitsText = jQuery('[data-loyalty-gift]').text().toLowerCase();

      const keywords = ['연료', '주유', 'fuel', '燃料', '満タン', 'carburant'];
      const hasFuelBenefit = keywords.some(
        k => benefitsText.includes(k.toLowerCase())
      );

      if ( hasFuelBenefit ) {
        // 체크 해제 + 비활성화 + change 이벤트 트리거(요약 영수증 동기화용)
        $fuelAcc.checked(false).disable().trigger('change');
      }
    }
    else $fuelAcc.enable();
  }

  // 🌟 [수정] 생년월일 선택 시 픽업일 기준으로 나이 계산 (픽업일 없으면 오늘 날짜 기준)
  #calculateAge($dobInput, $ageOutput) {
    const dobDateStr = $dobInput.data('datetimerSelected');

    // 생년월일이 없으면 종료
    if ( !dobDateStr ) return;

    // 픽업일이 없으면 오늘 날짜 사용
    let pickupDateStr = jQuery('[data-pickup-date]').data('pickupDate');
    if ( !pickupDateStr )
      pickupDateStr = new Date().toISOString().split('T')[0];

    // YYYY-MM-DD 파싱
    const [pY, pM, pD] = pickupDateStr.split('-').map(Number);
    const [dY, dM, dD] = dobDateStr.split('-').map(Number);

    let age = pY - dY;
    // 픽업일의 월/일이 생일보다 전이라면 아직 만 나이가 되지 않은 것이므로 1살 빼기
    if ( pM < dM || ( pM === dM && pD < dD ) ) age--;

    $ageOutput.countTo(age);
  }

  // 🌟 [수정] 해외 주소 토글 (재사용 가능하게 파라미터화 - 접두사 기반)
  #toggleAddressDialog(event, fieldPrefix = 'book') {
    const isOverseas = event.currentTarget.checked;
    const $addr = jQuery(`input[name="${fieldPrefix}-address"]`);
    const $zip = jQuery(`input[name="${fieldPrefix}-address-zipcode"]`);
    const $country = jQuery(`input[name="${fieldPrefix}-address-country"]`);

    if ( isOverseas ) {
      $addr.removeDatattr('addressDialog');
      $zip.removeDatattr('addressDialog');
      $country.readonly(false);

      // 🌟 [핵심 방어막] 유저가 직접 마우스로 클릭했을 때(originalEvent)만 값을 비움!
      // 리셋 중에는 Form 클래스가 이미 원본 값을 복원해 두었으므로 절대 건드리지 않음.
      if ( event.originalEvent ) {
        $country.value('').removeDatattr('autocompleteSelected preventEdit').trigger('focus');
      }
    }
    else {
      $addr.datattr({addressDialog: 'latin'});
      $zip.datattr({addressDialog: 'zip' });
      $country.readonly(true);

      // 🌟 [핵심 방어막] 유저가 체크 해제했을 때만 기본값(KR)으로 덮어씀!
      if ( event.originalEvent ) {
        $country.datattr({
          autocompleteSelected: $country.data('defaultAutocompleteSelected'),
          preventEdit: ''
        }).value($country.data('defaultValue'));
      }
    }
  }

  #toggleArrival(event) {
    const method = event.currentTarget.value; // 'flight', 'notyet', 'walkin'
    const $flightDetails = jQuery('input[name="book-arrival-flight"], input[name="book-arrival-flight-num"]');
    const $time = jQuery('input[name="book-arrival-time"]');

    if ( method === 'flight' ) {
      $flightDetails.disabled(false);
      $time.disabled(false);
    }
    else if ( method === 'notyet' ) {
      $flightDetails.value('').disabled(true).removeDatattr('hasValue');
      $time.value('').disabled(true).removeDatattr('hasValue');

      // 🌟 비활성화 시 잔존하는 에러 툴팁 즉시 청소
      if ( typeof Input !== 'undefined' ) {
        $flightDetails.each((_, el) => Input.clearError(jQuery(el)));
        $time.each((_, el) => Input.clearError(jQuery(el)));
      }
    }
    else if ( method === 'walkin' ) {
      $flightDetails.value('').disabled(true).removeDatattr('hasValue');
      $time.disabled(false);

      // 🌟 항공편 정보만 에러 청소
      if ( typeof Input !== 'undefined' ) {
        $flightDetails.each((_, el) => Input.clearError(jQuery(el)));
      }
    }
  }

  // 🌟 [NEW] 약관 필수 동의 여부를 추적하여 제출 버튼 활성화/비활성화 제어
  #toggleSubmit() {
    const $form = jQuery('#book-details');
    if ( !$form.be() ) return;

    const $submitBtn = $form.find('button[type="submit"][data-book-action="book"]');
    const $requiredChecks = $form.find('[data-term-each] input[required]');

    // 필수 체크박스 중 하나라도 체크가 안 되어 있으면 true 반환
    const hasUncheckedRequired = $requiredChecks.filter(':not(:checked)').length > 0;

    // 상태에 따라 버튼 잠금 토글
    $submitBtn.disabled(hasUncheckedRequired);

    // 버튼 상태가 변할 때 혹시 화면에 떠 있는 낡은 툴팁이 있다면 화면을 깨끗하게 정리
    if ( typeof Tooltip !== 'undefined' ) Tooltip.remove();
  }

  // 🌟 [수정] 파일의 상태 변화(추가/삭제)를 단 하나의 메서드에서 완벽 제어
  async #handleFileChange(event) {
    const $input = jQuery(event.currentTarget);
    const file = event.currentTarget.files[0];

    // 🟢 CASE A: 파일이 새로 선택된 경우 -> 업로드 진행
    if ( file ) {
      // 프론트엔드 1차 유효성 검사 (용량 체크)
      const maxSizeMB = parseFloat($input.data('fileMaxsize')) || 5;
      const maxSizeBytes = maxSizeMB * 1024 * 1024;

      if ( file.size > maxSizeBytes ) {
        Dialog.errorSimple($input.data('errorMsgSize'));
        $input.value(''); // 파일 선택 초기화 (이때 다시 change가 발생하지만 위 마크 때문에 안전함)
        return;
      }

      const formData = new FormData();
      formData.append('passport-image', file);

      $input.disable();
      Loading.show();

      try {
        const response = await jQuery.ajax({
          url: '/js/ajax/@page/book-passport-upload.php',
          method: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          dataType: 'json'
        });

        if ( response.success ) {
          $input.closest('.label').addClass('is-uploaded');
          Toast.open(response.message || 'Upload complete.');
        }
        else {
          Dialog.errorSimple(response.message);
          $input.value('');
        }
      }
      catch (error) {
        Dialog.error('Network error during file upload.');
        $input.value('');
      }
      finally {
        $input.enable();
        Loading.hide();
      }
    }
    // 🔴 CASE B: 파일 인풋이 비워진 경우 (X 버튼 클릭 등) -> 서버 임시 파일 삭제 진행
    else {
      // 찌꺼기 방지: 기존에 업로드 성공 상태(.is-uploaded)였을 때만 서버에 삭제 요청을 보냅니다.
      const $label = $input.closest('.label');
      if ( !$label.hasClass('is-uploaded') ) return;

      $input.disable();
      Loading.show();

      try {
        const response = await jQuery.ajax({
          url: '/js/ajax/@page/book-passport-delete.php',
          method: 'POST',
          dataType: 'json'
        });

        $label.removeClass('is-uploaded');

        if ( response.success ) {
          Toast.open(response.message || 'File deleted.');
        }
      }
      catch (error) {
        $label.removeClass('is-uploaded');
      }
      finally {
        $input.enable();
        Loading.hide();
      }
    }
  }

  // 🌟 [NEW] 결제 수단 토글 및 폼 활성/비활성 제어
  #togglePayment(event) {
    const selectedMethod = event.currentTarget.value; // 'card-kr', 'bank-kr' 등

    // 1. 모든 결제 패널 닫기 및 내부 입력 폼 비활성화
    const $allPanels = jQuery('.payment-panel');
    $allPanels.hidden(true); // 익스텐션 적용

    // 숨겨진 패널 내부의 인풋들을 비활성화하여 유효성 검사와 데이터 전송에서 제외
    $allPanels.find('input, select, textarea').disabled(true);

    // 2. 선택된 결제 패널 열기 및 내부 입력 폼 활성화
    const $targetPanel = jQuery(`#panel-${selectedMethod}`);
    if ( $targetPanel.be() ) {
      $targetPanel.hidden(false); // 익스텐션 적용
      $targetPanel.find('input, select, textarea').disabled(false);
    }
  }

  #handleSpecialCard(event) {
    const $select = jQuery(event.currentTarget);
    const $selected = $select.find('option:selected');
    const val = $select.val();

    const $noticeCvc = jQuery('[data-card-kr-note="cvc"]');
    const $noticePwd = jQuery('[data-card-kr-note="pwd"]');

    // 1. 카드를 선택하지 않은 상태(기본값)로 돌아가면 모두 숨김
    if (!val) {
      $noticeCvc.hidden(true);
      $noticePwd.hidden(true);
      return;
    }

    // 2. data 속성 값 및 선택된 카드 이름(텍스트) 가져오기
    const isCvc = $selected.data('is-cvc') == 1; // 1이면 true
    const isPwd = $selected.data('is-pwd') == 1; // 1이면 true
    const cardName = $selected.text();

    // 3. CVC 조건 처리: 텍스트 삽입 후 노출/숨김
    if (isCvc) {
      $noticeCvc.find('[data-card-name-placeholder]').text(cardName);
      $noticeCvc.hidden(false);
    } else $noticeCvc.hidden(true);

    // 4. PWD 조건 처리: 텍스트 삽입 후 노출/숨김
    if (isPwd) {
      $noticePwd.find('[data-card-name-placeholder]').text(cardName);
      $noticePwd.hidden(false);
    } else $noticePwd.hidden(true);
  }

  // 🌟 [수정] '전체 동의' 클릭 시 버튼 상태 동기화
  #handleTermCheckAll(event) {
    const isChecked = jQuery(event.currentTarget).prop('checked');
    jQuery('[data-term-each] input[type="checkbox"]')
      .checked(isChecked)
      .trigger('change');

    this.#toggleSubmit(); // 🌟 제출 버튼 제어기 호출
  }

  // 🌟 [수정] '개별 약관' 클릭 시 전체 동의 및 버튼 상태 동기화
  #handleTermCheckEach() {
    const $subChecks = jQuery('[data-term-each] input[type="checkbox"]');
    const totalCount = $subChecks.length;
    const checkedCount = $subChecks.filter(':checked').length;

    jQuery('[data-term-check-all]').checked(totalCount === checkedCount);

    this.#toggleSubmit(); // 🌟 제출 버튼 제어기 호출
  }

  // 🌟 [추가] 쿠폰 선택 변경 비동기 핸들러
  async #handleCouponChange(event) {
    const $select = jQuery(event.currentTarget);
    const couponId = parseInt($select.value(), 10) || 0;

    // 통신 중 중복 클릭 방지 및 로딩 화면 노출
    $select.disable();
    Loading.show();

    try {
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/book-session-coupon.php',
        method: 'POST',
        data: { coupon_id: couponId },
        dataType: 'json'
      });

      if ( response.success ) window.location.reload();
      else {
        Dialog.errorSimple(response.message || 'Failed to apply coupon.');
        $select.enable();
        Loading.hide();
      }
    }
    catch (error) {
      Dialog.error('Network error during coupon application.');
      $select.enable();
      Loading.hide();
    }
  }

  watch() {
    if ( jQuery('#pickup-center').be() ) {
      this.#cascade();
      this.#initSummary();
    }

    $doc.on('click', '[data-book-action="next"]', (event) => {
      this.#next(event)
    });
    $doc.on('click', '[data-book-action="prev"]', (event) => {
      this.#prev(event)
    });
    $doc.on('click', '[data-book-action="modify"]', (event) => {
      this.#modify(event)
    });

    $doc.on('change', '#sort-vehicles', () => this.#loadVehicles());

    $doc.on('click', '[data-book-action="select-vehicle"]', (event) => {
      this.#selectVehicle(event);
    });

    // [NEW] 3단계 Next 버튼 이벤트 바인딩
    $doc.on('click', '[data-book-action="select-options"]', (event) => {
      this.#selectOptions(event);
    });

    // 🌟 [NEW] 4단계 최종 폼 제출 (Submit) 이벤트 바인딩
    // 버튼 클릭이 아닌 form의 submit 이벤트를 캡처하여 HTML5 validation과 매끄럽게 연동합니다.
    $doc.on('submit', '#book-details', (event) => {
      this.#submitBook(event);
    });

    // [NEW] 플랜 옵션 라디오 버튼 토글 이벤트
    $doc.on('change', 'input[name="option-plan"]', (event) => {
      this.#planSelect(event);
    });

    // [NEW] 액세서리 수량 및 체크박스 변경 이벤트
    $doc.on('input change', 'input[name^="accessories["]', (event) => {
      this.#updateAccessory(event);
    });

    // 🌟 1. 로열티 체크박스 토글 이벤트 리스너 바인딩
    $doc.on('change', 'input[data-check-if-loyalty]', (event) => {
      this.#handleLoyaltyFuel(event);
    });

    // 🌟 2. [추가] 문서 로드 시점에 이미 checked 상태인 요소가 있다면 강제 실행!
    // jQuery(셀렉터).each()를 쓰면 페이지 내에 해당 요소가 존재할 때만 루프를 돌므로 안전합니다.
    jQuery('input[data-check-if-loyalty]:checked').each((_, elem) => {
      // #handleLoyaltyFuel 메서드가 event.currentTarget을 기대하므로
      // 더미 event 객체 구조를 만들어 꽂아줍니다.
      this.#handleLoyaltyFuel({ currentTarget: elem });
    });

    // 🌟 [수정] 생년월일(DOB) 인풋 값이 변경될 때마다 나이 재계산 - 두 ID 모두 지원
    $doc.on('change', '#book-dob', () => {
      this.#calculateAge(
        jQuery('#book-dob'), jQuery('output[name="book-age"]')
      );
    });

    $doc.on('change', '#client-dob', () => {
      this.#calculateAge(
        jQuery('#client-dob'), jQuery('output[for="client-dob"]')
      );
    });

    // 🌟 [수정] 해외 주소 토글 - book 필드
    $doc.on('change', '#if-book-address-oversea', (event) => {
      this.#toggleAddressDialog(event, 'book');
    });

    // 🌟 [NEW] 해외 주소 토글 - client 필드
    $doc.on('change', '#if-client-address-oversea', (event) => {
      this.#toggleAddressDialog(event, 'client');
    });

    $doc.on('change', 'input[name="book-arrival"]', (event) => {
      this.#toggleArrival(event)
    });

    // 🌟 [최종 정리] 파일 인풋의 변화(선택/비우기 모두 포함)는 이 리스너 하나가 전담 마크
    $doc.on('change', 'input[name="book-file-pass"]', (event) => {
      this.#handleFileChange(event);
    });

    // 🌟 [NEW] 결제 수단 라디오 버튼 변경 이벤트 바인딩
    $doc.on('change', 'input[name="book-payment"]', (event) => {
      this.#togglePayment(event);
    });

    // 🌟 [NEW] 페이지 로드 시 이미 'checked' 상태인 라디오 버튼 기준 초기화 강제 실행
    // (이 작업을 해야 로드 직후 다른 닫혀있는 패널의 인풋들이 깔끔하게 disabled 됩니다)
    jQuery('input[name="book-payment"]:checked').each((_, elem) => {
      this.#togglePayment({ currentTarget: elem });
    });

    $doc.on('change', '#card-company-kr', (event) => {
      this.#handleSpecialCard(event);
    });

    // [이벤트 바인딩 1] 전체 동의 이벤트
    $doc.on('change', '[data-term-check-all]', (event) => {
      this.#handleTermCheckAll(event);
    });

    // [이벤트 바인딩 2] 개별 약관 이벤트
    $doc.on('change', '[data-term-each] input[type="checkbox"]', () => {
      this.#handleTermCheckEach();
    });

    // 🌟 [추가] 쿠폰 셀렉트 박스 변경 이벤트 바인딩
    $doc.on('change', 'select[name="book-coupon"]', (event) => {
      this.#handleCouponChange(event);
    });

    // 🌟 [추가] 4단계 페이지가 렌더링 된 직후, 약관 체크 상태를 읽어 제출 버튼 잠금 동기화
    if ( jQuery('#book-details').be() ) {
      this.#toggleSubmit();
    }
  }
}


export class Signup {
  #timerInterval = null; // 🌟 타이머 제어를 위한 내부 변수 선언

  constructor(selector = '#sign-up') { this.selector = selector; }

  // 🌟 [NEW] HTML datetime 속성을 읽어 작동하는 독립형 타이머 엔진
  #startTimer() {
    const $timerElem = jQuery(this.selector).find('time[data-timer]');
    const datetimeStr = $timerElem.attr('datetime') || '03:00'; // 안전장치 기본값

    // "10:00" 형식의 문자열을 분(mins)과 초(secs)로 파싱하여 총 초(Seconds) 단위로 변환
    const [mins, secs] = datetimeStr.split(':').map(Number);
    let remaining = (mins * 60) + secs;

    // 기존에 돌고 있던 타이머가 있다면 (재전송 시) 초기화
    if ( this.#timerInterval ) clearInterval(this.#timerInterval);

    // 초를 MM:SS 포맷 문자열로 변환하는 헬퍼 함수
    const formatTime = (totalSeconds) => {
      const m = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
      const s = String(totalSeconds % 60).padStart(2, '0');
      return `${m}:${s}`;
    };

    // 1. 시작 즉시 &mdash; 를 지우고 텍스트 삽입 (예: 10:00)
    $timerElem.text(formatTime(remaining));

    // 2. 1초마다 카운트다운 실행
    this.#timerInterval = setInterval(() => {
      remaining--;

      if ( remaining <= 0 ) {
        // 타이머 만료 시 정지
        clearInterval(this.#timerInterval);
        $timerElem.text('00:00');

        // 🌟 시간 만료 시 보안을 위해 인증 번호 인풋 및 확인 버튼 비활성화 가드 처리
        jQuery('#client-email-verification-code').disable();
        jQuery('[data-verify-code-timer-group] button').disable();

        return;
      }

      $timerElem.text(formatTime(remaining));
    }, 1000);
  }

  // 🌟 [추가 1] 이메일 입력 실시간 감지 및 전송 버튼 활성화 제어
  #handleEmailInput(event) {
    const inputNode = event.currentTarget;
    const $input = jQuery(inputNode);

    // 🌟 [추가] 이미 인증이 완료되어 이메일 칸이 잠긴(readonly) 상태라면 로직 즉시 중단!
    // (전송 버튼이 다시 활성화되는 좀비 현상 원천 차단)
    if ( $input.readonly() ) return;

    const $sendBtn = $input.closest('form').find('#get-verification-code');

    // HTML5 네이티브 유효성 검증 (pattern="email" 및 required 통과 여부)
    if ( inputNode.checkValidity() ) $sendBtn.enable();
    else $sendBtn.disable();
  }

  // 🌟 [최적화] 코드 전송/재전송 버튼 클릭 이벤트
  async #handleSendCode(event) {
    const $sendBtn = jQuery(event.currentTarget);
    const $output = $sendBtn.siblings('output');
    const $emailInput = jQuery('#client-email');
    const $codeInput = jQuery('#client-email-verification-code');

    // 🌟 커스텀 익스텐션 .value() 사용 (공백 자동 trim 처리 포함)
    const mailValue = $emailInput.value();

    // 🌟 커스텀 익스텐션 .disable() 사용
    $sendBtn.disable();
    Loading.show();

    try {
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/signup-code-send.php',
        method: 'POST',
        data: { mail: mailValue },
        dataType: 'json'
      });

      // 🌟 [응답 분기 1] 성공적으로 메일이 발송된 경우
      if ( response.status === 'success' ) {
        // jQuery .data()는 HTML의 data-is-resent 속성을 camelCase(isResent)로 자동 파싱합니다.
        const isResent = $sendBtn.data('isResent') === true;

        if ( !isResent ) {
          // [최초 전송 성공 시]
          const sentMsg = $output.data('msgCodeSent');
          const afterText = $sendBtn.data('buttonTextAfterClicked');

          $output.text(sentMsg).css('opacity', '1');

          // 🌟 커스텀 익스텐션 .datattr() 활용 (버튼 텍스트 변경 후 data 속성 세팅 체이닝)
          $sendBtn.text(afterText).datattr({ 'isResent': true });

          // 🌟 커스텀 익스텐션 .datattr() 활용
          jQuery('[data-verify-code-timer-group]').datattr({ 'isOpen': '' });
          this.#startTimer();

          setTimeout(() => {
            $codeInput.focus();
          }, 50);
        }
        else {
          // [재전송 성공 시]
          const resentMsg = $output.data('msgCodeResent');
          $output.text(resentMsg);

          // 🌟 커스텀 익스텐션 폭풍 체이닝: 활성화 -> 값 비우기 -> 포커스
          $codeInput.enable().value('').focus();

          // 🌟 커스텀 익스텐션 .enable() 사용
          jQuery('[data-verify-code-timer-group] button').enable();

          this.#startTimer();
        }
      }

      // 🌟 [응답 분기 2] 이미 가입된 이메일인 경우
      else if ( response.status === 'already_registered' ) {
        const existMsg = $emailInput.data('errorMsgEmailAlreadyRegistered');

        // 🌟 [최적화] Input 클래스의 API를 호출하여 aria-invalid와 Tooltip을 한 방에 처리!
        // (이 툴팁과 invalid 속성은 사용자가 이메일 칸에 다시 타이핑을 하는 순간 Input의 watch()에 의해 자동으로 사라집니다.)
        Input.setError($emailInput, existMsg);

        $emailInput.focus();
        $output.text('');
      }

      // 🌟 [응답 분기 3] 서버 통신은 성공했으나 메일 발송에 실패한 경우
      else {
        const failMsg = $output.data('msgCodeFail');
        $output.text(failMsg);
      }
    }
    catch (error) {
      // 서버 에러(500) 등 네트워크 실패 시
      const failMsg = $output.data('msgCodeFail');
      $output.text(failMsg);
      Dialog.error(error);
    }
    finally {
      // 🌟 커스텀 익스텐션 .enable() 사용
      $sendBtn.enable();
      Loading.hide();
    }
  }

  // 🌟 [최적화] 인증 번호 입력 후 확인 버튼 클릭 이벤트
  async #verifyEmailCode(event) {
    const $verifyBtn = jQuery(event.currentTarget);
    const $codeInput = jQuery('#client-email-verification-code');
    const $emailInput = jQuery('#client-email');

    const codeValue = $codeInput.value();
    const mailValue = $emailInput.value();

    if ( !$codeInput[0].checkValidity() ) {
      $codeInput.focus();
      return;
    }

    $verifyBtn.disable();
    Loading.show();

    try {
      const datetimeStr = jQuery('time[data-timer]').attr('datetime') || '10:00';
      const [mins, secs] = datetimeStr.split(':').map(Number);
      const limitSecs = (mins * 60) + secs;

      const response = await jQuery.ajax({
        url: '/js/ajax/@page/signup-code-verify.php',
        method: 'POST',
        data: { mail: mailValue, code: codeValue, limit: limitSecs },
        dataType: 'json'
      });

      // [응답 분기 1] 인증 성공
      if ( response.status === 'success' ) {
        if ( this.#timerInterval ) clearInterval(this.#timerInterval);
        jQuery('time[data-timer]').text('00:00');

        $emailInput.readonly(true);
        $codeInput.disable();
        Input.clearError($codeInput);

        const verifiedText = $verifyBtn.data('buttonTextAfterVerified') || 'OK';
        $verifyBtn.text(verifiedText);

        // 🌟 [추가] 인증이 완료되었으므로 '전송/재전송' 버튼 영구 잠금
        jQuery('#get-verification-code').disable();
      }

      // 🌟 [응답 분기 2] 제한 시간 초과 (군더더기 없는 UX 및 value 버그 픽스)
      else if ( response.status === 'timeout' ) {
        // [!] 커스텀 .value() 대신 네이티브 .val()을 사용하여 이벤트 충돌 방지
        // 에러 툴팁은 띄우지 않고 조용하고 깔끔하게 입력창만 잠급니다.
        $codeInput.val('').removeDatattr('hasValue').disable();
      }

      // [응답 분기 3] 번호 불일치
      else {
        const errorMsg = $codeInput.data('errorMsgMatch');
        Input.setError($codeInput, errorMsg);

        // 여기서는 다시 타이핑을 해야 하므로 .value('')를 유지하여 change 이벤트를 태워도 무방합니다.
        $codeInput.value('').focus();
      }
    }
    catch (error) {
      const errDetail = error.status ? `HTTP ${error.status}` : 'Client Logic Error';
      Dialog.alertSimple(`Verification failed: ${errDetail}`);
    }
    finally {
      const isSuccess = $verifyBtn.text() === ($verifyBtn.data('buttonTextAfterVerified') || 'OK');
      const isTimeout = $codeInput.disabled();

      if ( !isSuccess && !isTimeout ) {
        $verifyBtn.enable();
      }

      Loading.hide();
    }
  }

  #toggleSubmit() {
    const $form = jQuery(this.selector);
    const $submitBtn = $form.find('button[type="submit"]');
    const $requiredChecks = $form.find('.legal-check input[required]');

    // required가 붙은 체크박스 중 하나라도 체크가 안 되어 있다면 true
    const hasUncheckedRequired = $requiredChecks.filter(':not(:checked)').length > 0;

    $submitBtn.disabled(hasUncheckedRequired);
  }

  // 1. [이벤트] '모두 동의' 체크박스 제어
  #handleCheckAll(event) {
    // 🌟 커스텀 getter: .checked() 사용
    const isChecked = jQuery(event.currentTarget).checked();
    const $subChecks = jQuery(this.selector).find('.legal-check input[type="checkbox"]');

    // 🌟 커스텀 setter: .each()가 내장되어 있으므로 컬렉션 전체에 일괄 적용됨
    $subChecks.checked(isChecked);

    // 버튼 상태 업데이트
    this.#toggleSubmit();
  }

  // 2. [이벤트] 하위 개별 체크박스 제어 및 '모두 동의' 상태 동기화
  #handleSubCheck() {
    const $form = jQuery(this.selector);
    const $allCheck = $form.find('[data-check-all]');
    const $subChecks = $form.find('.legal-check input[type="checkbox"]');

    const totalCount = $subChecks.length;
    const checkedCount = $subChecks.filter(':checked').length;

    // 🌟 커스텀 setter: .checked(Boolean) 사용
    $allCheck.checked(totalCount === checkedCount);

    // 버튼 상태 업데이트
    this.#toggleSubmit();
  }

  // 🌟 [완성] 회원 가입 폼 제출 (비동기 처리 및 유효성 정밀 검증)
  async #handleSubmit(event) {
    event.preventDefault();

    const formNode = event.currentTarget;
    const $form = jQuery(formNode);

    // 1. 유효성 검증 실패 시 첫 번째 에러 요소로 포커스 이동
    if ( !formNode.checkValidity() ) {
      const invalidSelectors = inputs.all.split(',').map((selector) => `${selector.trim()}:invalid`).join(',');
      const $firstInvalidInput = $form.find(invalidSelectors).first();

      $firstInvalidInput.smartScroll({ block: 'center' }).focus();
      return;
    }

    const $submitBtn = $form.find('button[type="submit"]');
    $submitBtn.disable();
    Loading.show();

    try {
      // 🌟 2. serialize()가 놓치는 커스텀 data 속성값 수동 추출
      // jQuery는 data-autocomplete-selected를 자동으로 camelCase(autocompleteSelected)로 파싱합니다.
      const telIDD = $form.find('[name="client-tel-idd"]').data('autocompleteSelected') || '';
      const birthDate = $form.find('[name="client-dob"]').data('datetimerSelected') || '';
      const addressNAT = $form.find('[name="client-address-country"]').data('autocompleteSelected') || '';

      // 🌟 3. 기본 폼 데이터에 추출한 데이터를 URL 인코딩하여 결합
      const payload = $form.serialize()
        + `&tel_IDD=${encodeURIComponent(telIDD)}`
        + `&birth_date=${encodeURIComponent(birthDate)}`
        + `&address_NAT=${encodeURIComponent(addressNAT)}`;

      // 4. 백엔드 전송
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/signup-register.php', // 🌟 파일명 변경 반영
        method: 'POST',
        data: payload, // 🌟 결합된 최종 Payload 전송
        dataType: 'json'
      });

      if ( response.success ) {
        const currentLang = root.lang || 'ko';
        // 가입 완료 고유 페이지로 이동
        window.location.href = `/${currentLang.toLowerCase()}/sign-up/complete`;
      }
      else {
        // 서버 비즈니스 로직 에러 (예: 이메일 중복, 인증 티켓 없음 등)
        Dialog.error(response.message || 'Registration failed.');
        $submitBtn.enable();
      }
    }
    catch (error) {
      // 서버 에러 (500) 또는 네트워크 실패
      const errDetail = error.status ? `HTTP ${error.status}` : 'Client Logic Error';
      Dialog.error(`Server error: ${errDetail}`);
      $submitBtn.enable();
    }
    finally {
      Loading.hide();
    }
  }

  // 🌟 이벤트 매핑
  watch() {
    // 🌟 [NEW] 이메일 입력 감지 (타이핑할 때마다 패턴 유효성 체크)
    $doc.on('input', `${this.selector} #client-email`, (event) =>
      this.#handleEmailInput(event)
    );

    // 🌟 [NEW] 인증 번호 전송 버튼 클릭
    $doc.on('click', `${this.selector} #get-verification-code`, (event) =>
      this.#handleSendCode(event)
    );

    // 🌟 [NEW] 인증 번호 확인 버튼 클릭
    $doc.on('click', `${this.selector} [data-verify-code-timer-group] button`, (event) =>
      this.#verifyEmailCode(event)
    );

    // [전체 동의] 체크박스
    $doc.on('change', `${this.selector} [data-check-all]`, (event) =>
      this.#handleCheckAll(event)
    );

    // [개별 동의] 하위 체크박스들
    $doc.on('change', `${this.selector} .legal-check input[type="checkbox"]`, (event) =>
      this.#handleSubCheck(event) // (event 파라미터를 넘겨주도록 통일)
    );

    // [폼 제출] 회원가입 진행
    $doc.on('submit', this.selector, (event) => this.#handleSubmit(event));
  }
}


export class Log {
  constructor(selector = '[data-logout]') { this.selector = selector; }

  // 🌟 로그아웃 실행 비동기 핸들러
  async #handleLogout(event) {
    event.preventDefault(); // a 태그 기본 동작 차단
    Loading.show();

    try {
      // 1. AJAX로 백엔드 세션/쿠키 파기 요청
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/logout.php',
        method: 'POST',
        dataType: 'json'
      });

      if ( response.success ) {
        // 2. 🌟 프론트엔드 로직 최소화 (단일 진실 공급원 원칙)
        // 세션이 파기된 상태로 현재 페이지를 무조건 새로고침합니다.
        // - 보안 페이지: PHP 권한 체크에 걸려 메인/로그인 창으로 자동 튕겨나감
        // - 공개 페이지: 로그인 버튼이 다시 활성화된 상태로 자연스럽게 갱신됨
        window.location.reload();
      } else {
        Dialog.error('Logout processing failed.');
        Loading.hide();
      }
    }
    catch (error) {
      Dialog.error('Network error during logout.');
      Loading.hide();
    }
  }

  // 🌟 [완성] 로그인 폼 제출 비동기 핸들러
  async #handleLogin(event) {
    // 1. 폼 제출 시 페이지가 완전히 리로드되는 기본 동작을 막습니다.
    event.preventDefault();

    const $form = jQuery(event.currentTarget);

    jQuery('#login-message').prop('hidden', true).text('');
    $form.find('input[name="login-id"], input[name="login-pw"]').aria('invalid', '');

    // 2. 통신 시작과 동시에 로딩 스피너 작동
    Loading.show();

    const formData = $form.serializeArray();

    // 🌟 0. 브라우저 타임존을 감지하여 formData 배열에 슬쩍 끼워 넣습니다.
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    formData.push({ name: 'user_timezone', value: tz });

    // 1. 브라우저 임시 메모리에서 아까 저장해둔 목적지를 꺼냅니다.
    let returnUrl = sessionStorage.getItem('returnURL');

    // 🌟 2. [추가된 안전망] 저장된 목적지가 없는데, 현재 화면이 전용 로그인 페이지가 아니라면?
    // (예: 4단계 인라인 폼 로그인) -> 현재 페이지 주소를 목적지로 강제 지정!
    if ( !returnUrl && !window.location.pathname.includes('/log-in') ) {
      returnUrl = window.location.pathname + window.location.search;
    }

    if ( returnUrl ) {
      formData.push({ name: 'returnURL', value: returnUrl }); // 데이터에 쏙 끼워넣기
      sessionStorage.removeItem('returnURL'); // 사용 완료 후 즉시 파기
    }

    // --- 👆 여기까지 수정 👆 ---

    try {
      // 3. 백엔드 API로 로그인 요청 전송
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/login.php',
        method: 'POST',
        // serialize()를 쓰면 폼 내부의 id, pw, remember-me 값이 알아서 쿼리 스트링으로 변환됩니다.
        data: jQuery.param(formData),
        dataType: 'json'
      });

      // 4. 로그인 성공 시
      if ( response.success ) {
        // 🌟 [개선] 백엔드가 명시적인 이동 주소(redirect)를 내려주면 그곳으로 이동하고,
        // 그렇지 않으면 원래 의도대로 현재 페이지를 시원하게 새로고침합니다.
        if ( response.redirect ) window.location.href = response.redirect;
        else window.location.reload();
      }
      // 5. 로그인 실패 시
      else {
        Loading.hide();

        // 입력 때문에 생긴 오류(빈 값, 자격 오류)만 폼 안에 보여 줌. 서버·통신 오류는 입력과 무관하므로 기존대로 팝업
        if ( response.reason === 'credential' || response.reason === 'missing' ) {
          // 어느 쪽이 틀렸는지 알려 주지 않도록 이메일과 비밀번호 칸을 함께 붉게 표시하고, 문장은 한 번만
          jQuery('#login-message').text(response.message).prop('hidden', false);
          $form.find('input[name="login-id"], input[name="login-pw"]').aria('invalid', 'true');
          if ( response.reason === 'credential' ) $form.find('input[name="login-pw"]').value('').trigger('focus'); // 틀린 비밀번호는 지우고 바로 다시 입력
        }
        else Dialog.errorSimple(response.message || 'Login failed.');
      }
    }
    catch (error) {
      Dialog.error('Network error during login.');
      Loading.hide();
    }
  }

  // 🌟 비밀번호 찾기 폼 제출 비동기 핸들러
  async #handleForgotPassword(event) {
    event.preventDefault();

    const $form = jQuery(event.currentTarget);

    // 🌟 [수정됨] 브라우저 네이티브 팝업은 영원히 안녕!
    // 우리가 완성한 Input 클래스의 통합 검증 엔진을 호출하여 커스텀 에러 툴팁을 띄웁니다.
    if ( !Input.validateForm($form) ) return;

    Loading.show();

    try {
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/login-forgot-password.php',
        method: 'POST',
        data: $form.serialize(),
        dataType: 'json'
      });

      if ( response.success ) {
        Dialog.alert(
          response.message || 'A reset link has been sent to your email.',
          response.title || 'Sending Reset Link'
        );
        Loading.hide();
      }
      else {
        Dialog.errorSimple(response.message || 'Processing failed.');
        Loading.hide();
      }
    }
    catch (error) {
      Dialog.error('Network error during request.');
      Loading.hide();
    }
  }

  // 🌟 비밀번호 재설정 폼 제출 비동기 핸들러
  async #handleResetPassword(event) {
    event.preventDefault();

    const $form = jQuery(event.currentTarget);

    if ( !Input.validateForm($form) ) return;

    Loading.show();

    try {
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/login-reset-password.php',
        method: 'POST',
        data: $form.serialize(),
        dataType: 'json'
      });

      Loading.hide(); // 다이얼로그가 뜨기 전에 로딩바를 먼저 끕니다.

      if ( response.success ) {
        // 🌟 콜백 대신 await 사용! 다이얼로그가 닫힐 때까지 기다립니다.
        await Dialog.alertSimple(response.message);

        // 유저가 다이얼로그의 [확인]을 누르면 아래 코드가 실행되며 로그인 폼으로 이동!
        if ( response.redirect ) window.location.href = response.redirect;
      }
      else {
        // 에러 발생 시 에러 창을 띄우고
        await Dialog.errorSimple(response.message || 'Processing failed.');

        // 닫기를 누르면 백엔드가 지정해준 실패 복귀 주소(비밀번호 찾기 창)로 강제 이동!
        if ( response.redirect ) window.location.href = response.redirect;
      }
    }
    catch (error) {
      Loading.hide();
      Dialog.error('Network error during request.');
    }
  }

  // 🌟 [신규 추가] 타임존 실시간 교정 비공개 메서드
  async #syncTimezone() {
    // 1. 브릿지 변수가 없다면 (비로그인 상태) 즉시 검사 종료
    if ( typeof window.SERVER_TIMEZONE === 'undefined' ) return;

    const serverTz = window.SERVER_TIMEZONE;
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

    // 2. 타임존 불일치 감지 (국가 이동 등)
    if ( serverTz !== browserTz ) {
      try {
        const response = await jQuery.ajax({
          url: '/js/ajax/@page/login-timezone.php',
          method: 'POST',
          data: { timezone: browserTz },
          dataType: 'json'
        });

        // 3. 백엔드 세션/DB 교정 완료 후 현지 시간 기준으로 화면 리로드
        if ( response.success ) window.location.reload();
      }
      catch (error) {
        // 교정에 실패하더라도 사용자의 화면 이용을 방해하지 않도록 조용히 넘깁니다.
        Dialog.errorSimple('Timezone sync failed:', error);
      }
    }
  }

  watch() {
    // 1. 로그아웃 링크 클릭 감지
    $doc.on('click', this.selector, (event) => this.#handleLogout(event));

    // 2. 🌟 [추가] 로그인 폼(#login)의 submit 이벤트 감지
    $doc.on('submit', '#login', (event) => this.#handleLogin(event));

    // 로그인 실패 표시는 다시 입력하기 시작하면 이메일·비밀번호 칸이 함께 풀림
    $doc.on('input', '#login input[name="login-id"], #login input[name="login-pw"]', () => {
      jQuery('#login input[name="login-id"], #login input[name="login-pw"]').aria('invalid', '');
      jQuery('#login-message').prop('hidden', true).text('');
    });

    // 3. 🌟 [추가] 비밀번호 찾기 폼(#forgot-password)의 submit 이벤트 감지
    $doc.on('submit', '#forgot-password', (event) =>
      this.#handleForgotPassword(event)
    );

    // 4. 🌟 [추가] 비밀번호 재설정 폼(#reset-password)의 submit 이벤트 감지
    $doc.on('submit', '#reset-password', (event) =>
      this.#handleResetPassword(event)
    );

    // 🌟 [추가] 로그인 페이지로 가는 링크 클릭 감지
    $doc.on('click', 'a[href*="/log-in"]', function() {
      // 이동을 막지 않고 놔둡니다.
      // 단, 이동하기 직전에 브라우저 임시 메모리에 현재 주소를 저장합니다.
      const currentPath = window.location.pathname + window.location.search;
      sessionStorage.setItem('returnURL', currentPath);
    });

    // 🌟 2. [신규 추가] Log 클래스가 감시를 시작할 때 타임존 가드도 함께 백그라운드에서 실행!
    this.#syncTimezone();
  }
}


export class MyProfile {
  constructor() {
    this.$form = jQuery('#my-profile');
    if ( this.$form.be('not') ) return;

    this.$submit = this.$form.find('button[type="submit"]');
    this.$cancel = this.$form.find('[data-profile-edit="cancel"]');

    // 🌟 [수정된 부분] 자식 태그(아이콘)는 무시하고, 순수 텍스트 노드(nodeType === 3)의 글자만 추출!
    this.txtOrig = this.$submit.contents().filter(function() {
      return this.nodeType === 3 && this.nodeValue.trim() !== '';
    }).text().trim();
    this.txtSave = this.$submit.data('buttonTextAfterChange');

    this.$icon = this.$submit.find('[aria-hidden="true"]');
    this.icoOrig = this.$icon.text().trim();
    this.icoSave = this.$submit.data('iconAfterChange');

    this.isUnlocked = false;
    this.watch();
  }

  // 🔓/🔒 폼 잠금 및 해제 토글 (커스텀 익스텐션 및 상수 활용)
  #toggleInputs(state) {
    this.$form.find(inputs.all).each(function() {
      // const $el = jQuery(this);
      // if ( !$el.readonly() ) $el.disabled(!state);
      jQuery(this).disabled(!state)
    });
    // state가 true면 활성화(.disabled(false)), false면 비활성화(.disabled(true))
    this.$cancel.enabled(state);
  }

  // 🎨 버튼 UI 텍스트 & 아이콘 스위칭
  #updateSubmitUI(isChanged) {
    const text = isChanged ? this.txtSave : this.txtOrig;
    const icon = isChanged ? this.icoSave : this.icoOrig;

    this.$icon.text(icon);
    this.$submit.contents().filter(function() {
      return this.nodeType === 3 && this.nodeValue.trim() !== '';
    }).first().replaceWith(text + ' ');
  }

  #handleSubmit(event) {
    // 🛣️ 갈래길 A: 아직 잠겨있을 때 (수정하기 버튼 클릭)
    if ( !this.isUnlocked ) {
      event.preventDefault();
      this.isUnlocked = true;
      this.#toggleInputs(true); // 잠금 해제
      // 🌟 [수정된 부분] 콤마 병합 버그를 피하기 위해 filter()와 first()를 명시적 분리
      this.$form.find(inputs.all) // 숨겨져 있지 않고 읽기전용이 아닌 것만 체에 거름
        .filter(':not([readonly]):visible')
        .first().smartScroll({block: 'center'});
        // .first().focus(); // 가장 첫 번째 요소 (아마도 '영문 성' 필드) 포커스
      return;
    }

    // 🛣️ 갈래길 B: 열려있는데 값이 전혀 변하지 않았을 때 (.is-changed가 0개)
    if ( this.$form.find('.is-changed' ).length === 0) {
      event.preventDefault();
      return;
    }

    // 🛣️ 갈래길 C: 값 변경됨 -> 서버 전송 진행
    event.preventDefault();

    // 1. 프론트엔드 최종 유효성 검사 (우리가 만든 코어 엔진 출동)
    // 실패 시 Input 클래스가 알아서 에러 띄우고 포커스까지 보내주므로 여기서 쿨하게 종료
    if ( !Input.validateForm(this.$form) ) return;

    // 2. 중복 클릭 방지 (로딩 상태)
    this.$submit.disabled(true);
    this.$cancel.disabled(true);

    // 3. 폼 데이터 패킹
    const formData = Form.fetchFormData(this.$form);

    // 4. Fetch 통신 시작 (헤더 추가!)
    fetch('/js/ajax/@page/my-account-profile-update.php', {
      method: 'POST',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: formData
    })
    .then(response => {
      if ( !response.ok ) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(result => {
      if ( result.success ) {
        // 🌟 [NEW] 스냅샷을 굽기 전에, 서버에서 보내준 포맷팅 번호를 인풋에 반영합니다!
        if ( result.formattedTel ) {
          this.$form.find('input[name="client-tel"]')
            .value(result.formattedTel);
        }

        this.$form.find('.is-changed').removeClass('is-changed');
        this.$form.find(inputs.all).each(function() {
          const $el = jQuery(this);

          // 🌟 [UI 값 동기화] 선택형이 아닌 일반 텍스트 입력 엘리먼트의 가공되지 않은 공백을 서버 기준에 맞춰 깨끗하게 trim() 합니다.
          if ( !$el.is(inputs.choice) && this.value !== undefined ) {
            this.value = this.value.trim();
          }

          // 🌟 1. [핵심] 브라우저의 네이티브 리셋 기준점(Default) 자체를 현재 값으로 영구 갱신!
          if ( $el.is(inputs.choice) ) {
            this.defaultChecked = this.checked; // 네이티브 리셋용
            this.__initialState = this.checked; // Form 트래커용
          }
          else {
            this.defaultValue = this.value;     // 네이티브 리셋용
            this.__initialState = this.value;   // Form 트래커용
          }

          // 🌟 2. 커스텀 롤백(.rollback)을 위한 HTML 속성 스냅샷 갱신
          if ( this.__initialAttrs ) {
            this.__initialAttrs.clear();
            Array.from(this.attributes).forEach(attr => {
              this.__initialAttrs.set(attr.name, attr.value);
            });
          }
        });

        this.isUnlocked = false;
        this.#toggleInputs(false);
        this.#updateSubmitUI(false);

        // 🌟 [수정] 백엔드(PHP)에서 넘겨받은 메시지를 그대로 토스트에 띄웁니다.
        Toast.open(result.message);
      }
      else Dialog.error(result.message);
    })
    .catch(error => Dialog.error(`Fetch Error: ${error}`))
    .finally(() => this.$submit.disabled(false));
  }

  // 🌟 비밀번호 변경 폼 제출 비동기 핸들러
  async #handlePasswordChange(event) {
    event.preventDefault(); // method="dialog"에 의한 자동 닫힘 및 기본 제출 차단

    const $form = jQuery(event.currentTarget);
    const dialog = $form.closest('dialog').get(0); // 현재 폼을 감싸고 있는 다이얼로그 요소

    // 🌟 1. 취소 버튼 처리 (formnovalidate 속성을 달아둔 버튼)
    const submitter = event.originalEvent?.submitter;

    if ( submitter && submitter.value === 'cancel' ) {
      // 네이티브 close()를 호출하면, Dialog 클래스의 $dialog.one('close', ...) 리스너가 이를 감지하고 알아서 화면에서 부드럽게 지워줍니다.
      if ( dialog && typeof dialog.close === 'function' ) dialog.close();
      return;
    }

    // 🌟 2. 변경 버튼 처리: 코어 검증 엔진 가동
    if ( !Input.validateForm($form) ) return;

    Loading.show();

    try {
      // 3. 백엔드 통신
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/my-account-password-change.php',
        method: 'POST',
        data: $form.serialize(),
        dataType: 'json'
      });

      Loading.hide();

      if ( response.success ) {
        // 성공 시 폼 초기화 (나중에 다시 열 때를 대비)
        $form.trigger('reset');

        // 토스트 알림 띄우기
        Toast.open(response.message || 'Password has been successfully changed.');

        // 창 닫기 (Dialog 클래스 내부 로직 연동)
        if ( dialog && typeof dialog.close === 'function' ) dialog.close();
      }
      else Dialog.errorSimple(response.message);
    }
    catch (error) {
      Loading.hide();
      // 🌟 [Dialog 클래스 활용] 네트워크 통신 장애 시 다이얼로그로 에러 안내
      Dialog.errorSimple('Network error during password change.');
    }
  }

    // 🌟 회원 탈퇴 폼 제출 비동기 핸들러 (서버가 비밀번호와 진행 중인 예약을 확인한 뒤 탈퇴 처리)
  async #handleWithdraw(event) {
    event.preventDefault(); // method="dialog"에 의한 자동 닫힘 및 기본 제출 차단

    const $form = jQuery(event.currentTarget);
    const dialog = $form.closest('dialog').get(0);

    // 🌟 1. 취소 버튼 처리
    const submitter = event.originalEvent?.submitter;
    if ( submitter && submitter.value === 'cancel' ) {
      if ( dialog && typeof dialog.close === 'function' ) dialog.close();
      return;
    }

    // 🌟 2. 검증 엔진 가동
    if ( !Input.validateForm($form) ) return;

    Loading.show();

    try {
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/my-account-withdraw.php',
        method: 'POST',
        data: $form.serialize(),
        dataType: 'json'
      });

      Loading.hide();

      if ( response.success ) {
        if ( dialog && typeof dialog.close === 'function' ) dialog.close();

        // 안내창을 닫으면 홈으로 이동 (이미 로그아웃된 상태)
        await Dialog.alertSimple(response.message);
        window.location.href = '/';
      }
      else Dialog.errorSimple(response.message);
    }
    catch ( error ) {
      Loading.hide();
      Dialog.errorSimple('Network error during withdrawal.');
    }
  }

  watch() {
    // 1. 수정/저장 버튼 클릭 (Submit 이벤트 제어)
    this.$form.off('submit').on('submit', (event) => {
      this.#handleSubmit(event);
    });

    // 2. 입력 변화 감지 (Form 클래스에서 쏴주는 tracker:update 이벤트 수신)
    this.$form.on('tracker:update', (event, data) => {
      this.#updateSubmitUI(data.isChanged);
    });

    // 🌟 [핵심 수정] 폼 복구는 Form 클래스에 전적으로 위임하고, UI 상태만 제어합니다.
    if ( this.$cancel && this.$cancel.be() ) {
      this.$cancel.on('click', () => {
        this.isUnlocked = false;

        // 1. 브라우저 및 Form 클래스에 초기화 명령 하달! (나머진 Form 클래스가 알아서 완벽하게 처리함)
        this.$form.trigger('reset');

        // 2. MyProfile 전용 UI 상태(잠금 및 버튼 텍스트)만 원래대로 돌림
        this.#toggleInputs(false);
        this.#updateSubmitUI(false);
      });
    }

    // 🌟 4. [추가] 비밀번호 변경 다이얼로그 폼 제출 감지 (이벤트 위임 방식)
    $doc
      .off('submit.password-change', '[data-dialog="password-change"] form') // 기존에 바인딩된 이벤트 제거 후 재바인딩
      .on('submit.password-change', '[data-dialog="password-change"] form', (event) => {
        this.#handlePasswordChange(event);
      });

    // 🌟 회원 탈퇴 다이얼로그 폼 제출 감지 (비밀번호 변경과 같은 이벤트 위임 방식)
    $doc
      .off('submit.withdraw', '[data-dialog="withdraw"] form')
      .on('submit.withdraw', '[data-dialog="withdraw"] form', (event) => {
        this.#handleWithdraw(event);
      });
  }
}


export class Legal {
  constructor() {
    this.selector = '#legal-select';
    this.$select = jQuery(this.selector);
  }

  // 🌟 변경 이벤트 프라이빗 핸들러
  #handleChange(event) {
    const $target = jQuery(event.currentTarget);
    const selected = $target.value();
    const baseUrl = $target.data('baseUrl');

    if ( !baseUrl ) return;

    const targetUrl = selected === "" ? baseUrl : `${baseUrl}/@/${selected}`;

    window.location.href = targetUrl;
  }

  // 🌟 [추가] 전역으로 사용할 수 있도록 이동된 다이얼로그 호출 메서드
  async #openLegalDialog(event) {
    event.preventDefault();
    event.stopPropagation();

    const $mark = jQuery(event.currentTarget);
    const $input = $mark.closest('.label').find('input[type="checkbox"]');

    // 🌟 [방어막] 체크박스가 아예 없거나 name 속성이 없을 때 발생하는 TypeError 원천 차단
    const inputName = $input.be() ? ($input.name() || '') : '';

    const type = $mark.data('legalType') || inputName.replace('legal-', '');
    const version = $mark.data('legalVersion') || ( $input.be() ? $input.value() : '' );
    const title = $mark.data('legalView');

    // 🌟 [수정] 버전(version)이 없으면 PHP가 최신본을 부르도록 허용!
    // 단, 종류(type) 자체가 없으면 침묵하지 않고 에러 알림 팝업을 띄웁니다.
    // if ( !type ) {
    //   Dialog.errorSimple('약관 종류(type)를 찾을 수 없습니다.<br>HTML 태그에 <code>data-legal-type</code> 속성을 명시해 주세요.');
    //   return;
    // }

    try {
      const htmlContent = await jQuery.ajax({
        url: '/js/ajax/@page/legal.php',
        method: 'GET',
        data: { type, version }
      });

      await Dialog.legal(htmlContent, title);
    }
    catch (error) {
      Dialog.error(`Legal terms load failed: ${error.status}`);
    }
  }

  watch() {
    // 🌟 [교정] 조기 종료(return)를 없애고 요소가 실존할 때만 내부 이벤트를 바인딩합니다.
    if ( this.$select.be() ) {
      $doc
        .off('change.legal-version', this.selector)
        .on('change.legal-version', this.selector, (event) => {
          this.#handleChange(event);
        });
    }

    // 🌟 [추가] [data-legal-view] 선택자로 일원화하여 문서 전체(전역)에 이벤트 위임
    $doc
      .off('click.legal-view', '[data-legal-view]')
      .on('click.legal-view', '[data-legal-view]', (event) => {
        this.#openLegalDialog(event);
      });
  }
}


export class MyBookingArrival {
  constructor() {
    this.$form = jQuery('#my-booking-arrival');

    // 폼이 없으면 조기 종료
    if ( this.$form.be('not') ) return;

    this.$fieldset = this.$form.find('fieldset[data-my-booking-arrival]');
    this.$submit = this.$form.find('button[type="submit"]');
    // Button::cancel()로 생성된 버튼은 type="button"이므로 이를 이용해 선택
    this.$cancel = this.$form.find('footer button[type="button"]');

    this.isUnlocked = false; // 현재 폼의 잠금 상태
    this.watch();
  }

  // 🔓/🔒 폼 및 취소 버튼 잠금 제어 (커스텀 제이쿼리 익스텐션 활용)
  #toggleInputs(state) {
    this.isUnlocked = state;

    // state가 true(잠금 해제)면 disabled(false)로 비활성화 해제
    // state가 false(잠금)면 disabled(true)로 비활성화
    this.$fieldset.disabled(!state);
    this.$cancel.disabled(!state);
  }

  // 🌟 변경(Submit) 버튼 핸들러
  async #handleSubmit(event) {
    event.preventDefault();

    if ( !this.isUnlocked ) {
      this.#toggleInputs(true);
      this.$form.find(':input:not(button):visible:not([disabled])').first().smartScroll({ block: 'center' }).focus();
      return;
    }

    const hasChanges = this.$form.find('.is-changed').length > 0;

    if ( !hasChanges ) {
      const alertMessage = this.$submit.data('alertMessage');
      Dialog.alertSimple(alertMessage);
      this.#toggleInputs(false);
      return;
    }

    if ( !Input.validateForm(this.$form) ) return;

    // 🌟 [추가된 로직] 사용자가 입력한 데이터와 라벨을 실시간으로 스크래핑하여 HTML 리스트 조립
    const method = this.$form.find('input[name="book-arrival"]:checked').value();
    let detailsHtml = '';

    if ( method === 'notyet' ) {
      // 미정(notyet)인 경우 해당 라디오 버튼의 텍스트만 추출
      const labelText = this.$form.find('input[name="book-arrival"]:checked').closest('label').text().trim();
      detailsHtml = `<li><strong>${labelText}</strong></li>`;
    }
    else {
      const colon = $html.lang() === 'en' ? ': ' : ' : ';
      // 시간(time)은 walkin과 flight 공통 사항이므로 먼저 추출
      const timeVal = this.$form.find('input[name="book-arrival-time"]').value();
      const timeLabel = this.$form.find('input[name="book-arrival-time"]').prev('span').text().trim();
      detailsHtml += `<li>${timeLabel}${colon}<strong>${timeVal}</strong></li>`;

      // 항공편(flight)인 경우 추가 정보 추출
      if ( method === 'flight' ) {
        const airVal = this.$form.find('input[name="book-arrival-flight"]').value();
        const airLabel = this.$form.find('input[name="book-arrival-flight"]').prev('span').text().trim();

        const airNumVal = this.$form.find('input[name="book-arrival-flight-num"]').value();
        const airNumLabel = this.$form.find('input[name="book-arrival-flight-num"]').prev('span').text().trim();

        detailsHtml += `<li>${airLabel}${colon}<strong>${airVal}</strong></li>`;
        detailsHtml += `<li>${airNumLabel}${colon}<strong>${airNumVal}</strong></li>`;
      }
    }

    // 🌟 [수정된 로직] 추출한 리스트를 메시지 상단에 결합 (템플릿 리터럴 사용)
    const confirmTitle = this.$submit.data('confirmTitle');
    const confirmBtnText = this.$submit.data('confirmBtnText');
    const confirmMessage = `
      <p>${this.$submit.data('confirmMessage')}</p>
      <ul class="bullet-square gap-cozy">
        ${detailsHtml}
      </ul>
    `;

    // 조립된 메시지를 다이얼로그에 전달
    const isConfirmed = await Dialog.confirm(
      confirmMessage, confirmTitle, confirmBtnText
    );

    if ( isConfirmed !== 'confirm' ) return;

    this.$submit.disabled(true);
    Loading.show();

    try {
      const formData = Form.fetchFormData(this.$form);

      const response = await jQuery.ajax({
        url: '/js/ajax/@page/my-booking-arrival.php',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json'
      });

      Loading.hide();

      if ( response.success ) {
        await Dialog.alert(response.message, response.title);
        window.location.reload();
      }
      else {
        Dialog.error(response.message);
        this.$submit.disabled(false);
      }
    }
    catch (error) {
      Loading.hide();
      Dialog.error('Network error during request.');
      this.$submit.disabled(false);
    }
  }

  // 🌟 취소 버튼 핸들러 (비동기 async 추가)
  async #handleCancel(event) {
    event.preventDefault();

    const $btn = jQuery(event.currentTarget);
    const hasChanges = this.$form.find('.is-changed').length > 0;

    if ( hasChanges ) {
      // 🌟 1. 다이얼로그를 띄우고 사용자의 응답을 기다립니다.
      // 헷갈리지 않도록 텍스트를 명확하고 길게 풀어줍니다.
      const confirmTitle = $btn.data('confirmTitle');
      const confirmMessage = `<p>${$btn.data('confirmMessage')}</p>`;
      const confirmBtnText = $btn.data('confirmBtnText');
      const isConfirmed = await Dialog.confirm(
        confirmMessage, confirmTitle, confirmBtnText
      );

      // 🌟 2. 사용자가 '확인(confirm)'을 누르지 않았다면 (즉, '취소'나 바깥 배경을 눌렀다면) 함수 즉시 종료!
      if ( isConfirmed !== 'confirm' ) return;

      // 🌟 3. 사용자가 '확인'을 눌렀을 때만 아래 복원 로직이 실행됩니다.
      this.$form.find('input[type="radio"], input[type="checkbox"]').each(function() {
        if ( this.__initialState !== undefined ) {
          jQuery(this).checked(this.__initialState);
        }
      });

      this.$form.find('input[type="radio"]:checked, input[type="checkbox"]:checked').trigger('change');

      this.$form.find('input, select, textarea').not('[type="radio"], [type="checkbox"]').each(function() {
        const $el = jQuery(this);

        if ( this.__initialState !== undefined ) {
          $el.value(this.__initialState);
        }

        if ( this.__initialAttrs ) {
          if ( this.__initialAttrs.has('data-datetimer-selected') ) {
            $el.data('datetimerSelected', this.__initialAttrs.get('data-datetimer-selected'));
          }
          if ( this.__initialAttrs.has('data-autocomplete-selected') ) {
            $el.data('autocompleteSelected', this.__initialAttrs.get('data-autocomplete-selected'));
          }
        }
      });

      this.$form.find('.is-changed').removeClass('is-changed');
      this.$form.trigger('tracker:update', { isChanged: false });

      this.#toggleInputs(false);
    }
    else {
      // 변경 사항이 없으면 바로 닫음
      this.#toggleInputs(false);
    }
  }

  watch() {
    // 🌟 [안전 장치 추가] 폼이나 취소 버튼이 초기화되지 않았다면(해당 페이지가 아니라면) 이벤트 바인딩 조기 종료!
    if ( !this.$form || !this.$cancel ) return;

    // 🌟 .off()를 먼저 호출하여 중복 바인딩 차단
    this.$form
      .off('submit.myBookingArrival')
      .on('submit.myBookingArrival', (event) => this.#handleSubmit(event));

    this.$cancel
      .off('click.myBookingArrival')
      .on('click.myBookingArrival', (event) => this.#handleCancel(event));
  }
}


export class MyBookingControl {
  constructor() {
    // 1. 제어 버튼 요소들 찾기
    this.$controls = jQuery('[data-my-booking-control]');

    // 버튼이 존재하지 않으면 불필요한 이벤트 바인딩을 막기 위해 조기 종료
    if ( this.$controls.length === 0 ) return;

    this.watch();
  }

  // 🌟 제어 버튼 클릭 공통 핸들러
  async #handleClick(event) {
    event.preventDefault();

    const $btn = jQuery(event.currentTarget);
    const action = $btn.data('myBookingControl');

    // action 값(cancel, modify 등)에 따라 메서드 분기
    if ( action === 'cancel' ) await this.#handleCancel($btn);
    else if ( action === 'modify' ) await this.#handleModify($btn);
    else if ( action === 'withdraw' ) await this.#handleWithdraw($btn);
    else console.warn(`Undefined booking control action: ${action}`);
  }

  // 🌟 예약 철회(Withdraw) 액션 핸들러 (신규 추가)
  async #handleWithdraw($btn) {
    const $form = $btn.closest('form');

    // 1. 다이얼로그 구성을 위한 데이터 추출
    const confirmTitle = $btn.data('confirmTitle');
    const confirmMessage = `<p>${$btn.data('confirmMessage')}</p>`;
    // HTML에 confirmBtnText가 명시되어 있지 않은 경우 Title을 Fallback으로 사용
    const confirmBtnText = $btn.data('confirmBtnText');
    const confirmBtnClass = $btn.data('confirmBtnClass');
    const cancelBtnText = $btn.data('cancelBtnText');

    // 2. 다이얼로그 호출 및 확인 여부 대기
    const isConfirmed = await Dialog.confirm(
      confirmMessage, confirmTitle, confirmBtnText, confirmBtnClass, cancelBtnText
    );

    // 사용자가 '확인'을 누르지 않았다면 즉시 종료
    if ( isConfirmed !== 'confirm' ) return;

    // 3. 중복 클릭 방지를 위해 버튼 비활성화 및 로딩 표시
    $btn.disabled(true);
    Loading.show();

    try {
      const formData = $form.length > 0 ? Form.fetchFormData($form) : new FormData();
      formData.append('action', 'withdraw');

      // 🚨 주의: 철회 처리를 담당할 백엔드 파일명에 맞게 URL을 수정해 주세요.
      const response = await jQuery.ajax({
        url: '/js/ajax/@page/my-booking-withdraw.php',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json'
      });

      Loading.hide();

      if ( response.success ) {
        // 성공 시 메시지 출력 후 새로고침하여 바뀐 상태 반영
        await Dialog.alert(response.message, response.title);
        window.location.reload();
      }
      else {
        // 실패 시 에러 메시지 출력 후 버튼 활성화 복구
        Dialog.error(response.message);
        $btn.disabled(false);
      }
    }
    catch ( error ) {
      Loading.hide();
      Dialog.error('Network error during request.');
      $btn.disabled(false);
    }
  }

  // 🌟 예약 취소(Cancel) 액션 핸들러
  async #handleCancel($btn) {
    const $form = $btn.closest('form');
    let detailsHtml = '';

    // 1. 숨겨진 폼 데이터(hidden input)를 추출하여 detailsHtml 리스트 조립
    const bookingFee = $form.find('input[name="booking-fee"]').val();
    if ( bookingFee ) {
      detailsHtml += `<li>${bookingFee}</li>`;
    }

    const cancellationFee = $form.find('input[name="cancellation-fee"]').val();
    if ( cancellationFee ) {
      // 취소 수수료는 시각적 강조를 위해 클래스 추가
      detailsHtml += `<li>${cancellationFee}</li>`;
    }

    const cancelNote = $form.find('input[name="cancel-note"]').val();
    if ( cancelNote ) {
      cancelPlanNote = `<blockquote class="note"><p>${cancelNote}</p></blockquote>`;
    }
    else cancelPlanNote = '';

    // 2. 다이얼로그 구성을 위한 데이터 추출 및 결합
    const confirmTitle = $btn.data('confirmTitle');
    const confirmBtnText = $btn.data('confirmBtnText');
    const confirmBtnClass = $btn.data('confirmBtnClass');
    const confirmMessage = `
      <p>${$btn.data('confirmMessage')}</p>
      <ul class="bullet-square gap-cozy">
        ${detailsHtml}
      </ul>
      ${cancelPlanNote}
    `;
    const cancelBtnText = $btn.data('cancelBtnText');

    // 3. 다이얼로그 호출 및 확인 여부 대기
    const isConfirmed = await Dialog.confirm(
      confirmMessage, confirmTitle, confirmBtnText, confirmBtnClass, cancelBtnText
    );

    // 사용자가 '확인'을 누르지 않았다면 즉시 종료
    if ( isConfirmed !== 'confirm' ) return;

    // 4. 중복 클릭 방지를 위해 버튼 비활성화 및 로딩 표시 (jQuery 익스텐션 활용)
    $btn.disabled(true);
    Loading.show();

    try {
      // 폼 데이터를 스크래핑하고 액션 파라미터 추가
      const formData = $form.length > 0 ? Form.fetchFormData($form) : new FormData();
      formData.append('action', 'cancel');

      const response = await jQuery.ajax({
        url: '/js/ajax/@page/my-booking-cancel.php',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json'
      });

      Loading.hide();

      if ( response.success ) {
        // 성공 시 메시지 출력 후 새로고침하여 바뀐 상태 반영
        await Dialog.alert(response.message, response.title);
        window.location.reload();
      }
      else {
        // 실패 시 에러 메시지 출력 후 버튼 활성화 복구
        Dialog.error(response.message);
        $btn.disabled(false);
      }
    }
    catch ( error ) {
      Loading.hide();
      Dialog.error('Network error during request.');
      $btn.disabled(false);
    }
  }

  // 🌟 예약 수정(Modify) 액션 핸들러
  async #handleModify($btn) {
    // 1. 다이얼로그 구성을 위한 데이터 추출
    const confirmTitle = $btn.data('confirmTitle');
    const confirmMessage = `<p>${$btn.data('confirmMessage')}</p>`;
    const confirmBtnText = $btn.data('confirmBtnText');
    const proceedTo = $btn.data('confirmProceedTo');

    // 2. 다이얼로그 호출 및 확인 여부 대기
    // (CSS 클래스나 취소 버튼 텍스트가 HTML에 없다면 생략해도 Dialog 클래스에서 기본값으로 처리됩니다)
    const isConfirmed = await Dialog.confirm(
      confirmMessage, confirmTitle, confirmBtnText
    );

    // 사용자가 '확인'을 누르지 않았다면 즉시 종료
    if ( isConfirmed !== 'confirm' ) return;

    // 3. 페이지 이동 처리
    if ( proceedTo ) {
      // 로딩 화면을 살짝 띄워주면 화면 전환 시 깜빡임이나 중복 클릭을 방지하기 좋습니다.
      Loading.show();
      window.location.href = proceedTo;
    } else {
      Dialog.alertSimple('Redirect URL (data-confirm-proceed-to) is missing.');
    }
  }

  watch() {
    if ( this.$controls.length === 0 ) return;

    // 이벤트 위임(Event Delegation) 방식을 활용하여 문서(document) 레벨에서 클릭 감지
    jQuery(document)
      .off('click.myBookingControl')
      .on('click.myBookingControl', '[data-my-booking-control]', (event) => this.#handleClick(event));
  }
}


export class MyBookingInquiry {
  constructor() {
    // 1. 폼 요소 찾기
    this.$form = jQuery('#inquiry-ask');

    // 폼이 존재하지 않으면 불필요한 이벤트 바인딩을 막기 위해 조기 종료
    if ( this.$form.length === 0 ) return;

    this.watch();
  }

  // 🌟 폼 전송 액션 핸들러 (프라이빗 메서드)
  async #handleSubmit(event) {
    event.preventDefault();

    const $form = jQuery(event.currentTarget);

    // 🌟 HTML5 네이티브 유효성 검사 대신, 강력한 커스텀 Input 유효성 검사 엔진 활용!
    // 유효성 검사 실패 시 내부적으로 Tooltip을 띄우고 스크롤을 이동시킴 (false 반환)
    if ( !Input.validateForm($form) ) return;

    const $btn = $form.find('button[type="submit"]');

    // 중복 클릭 방지를 위해 버튼 비활성화 및 로딩 표시
    $btn.disabled(true);
    Loading.show();

    try {
      // MyBookingControl 클래스와 동일하게 커스텀 Form 메서드(또는 FormData) 활용
      const formData = Form.fetchFormData($form);

      const response = await jQuery.ajax({
        url: '/js/ajax/@page/my-account-inquiry.php',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json'
      });

      Loading.hide();

      if ( response.success ) {
        // 성공 시 Dialog 알림 후 리스트 페이지로 이동
        await Dialog.alert(response.message, response.title);
        window.location.href = '/my-account/inquiries';
      }
      else {
        // 실패 시 에러 메시지 출력 후 버튼 활성화 복구
        Dialog.error(response.message);
        $btn.disabled(false);
      }
    }
    catch ( error ) {
      Loading.hide();
      Dialog.error('Network error during request.');
      $btn.disabled(false);
    }
  }

  // 🌟 [추가] 폼 취소 액션 핸들러 (프라이빗 메서드)
  async #handleCancel(event) {
    event.preventDefault();

    const $btn = jQuery(event.currentTarget);

    // 1. 제목과 내용 인풋의 현재 값을 가져와 앞뒤 공백을 제거합니다.
    const subject = this.$form.find('[name="inquiry-subject"]').val().trim();
    const message = this.$form.find('[name="inquiry-message"]').val().trim();

    // 2. 입력된 내용이 전혀 없다면 다이얼로그를 띄우지 않고 즉시 리스트로 이동합니다.
    if ( !subject && !message ) {
      window.location.href = '/my-account/inquiries';
      return;
    }

    // 3. 입력된 내용이 하나라도 있다면 기존처럼 경고 다이얼로그를 호출합니다.
    const confirmTitle = $btn.data('confirmTitle');
    const confirmMessage = `<p>${$btn.data('confirmMessage')}</p>`;

    // 다이얼로그 호출 및 확인 여부 대기
    const isConfirmed = await Dialog.confirm(confirmMessage, confirmTitle);

    // 사용자가 '확인'을 누르지 않았다면 즉시 종료 (한 줄 처리)
    if ( isConfirmed !== 'confirm' ) return;

    // 확인을 눌렀다면 문의 내역 리스트 페이지로 복귀
    window.location.href = '/my-account/inquiries';
  }

  watch() {
    if ( this.$form.length === 0 ) return;

    // 이벤트 위임 및 네임스페이스를 활용하여 안전하게 submit 이벤트 감지
    jQuery(document)
      .off('submit.myBookingInquiry')
      .on('submit.myBookingInquiry', '#inquiry-ask', (event) => this.#handleSubmit(event));

      // 🌟 [추가] 취소 버튼(Click) 이벤트 감지
    // type="button"이면서 data-confirm-message 속성을 가진 버튼을 안전하게 타겟팅합니다.
    jQuery(document)
      .off('click.myBookingInquiryCancel')
      .on('click.myBookingInquiryCancel', '#inquiry-ask button[type="button"][data-confirm-message]', (event) => this.#handleCancel(event));
  }
}


export class ContactUs {
  static selector = '.map-jcg';

  #mapElements = [];
  #MapClass = null;
  #AdvancedMarkerElement = null;
  #PinElement = null;

  constructor() {}

  // [DOM] 개별 지도 컨테이너 리셋
  #resetMapContainer($oldMap) {
    if ( !$oldMap || !$oldMap.length ) return null;

    const lat = $oldMap.data('lat');
    const lng = $oldMap.data('lng');
    const name = $oldMap.data('name');
    const currentClass = $oldMap.attr('class');
    const currentID = $oldMap.id();
    const currentStyle = $oldMap.attr('style');

    const $newMap = jQuery('<div>', { class: currentClass, id: currentID });

    if ( lat ) $newMap.datattr({lat});
    if ( lng ) $newMap.datattr({lng});
    if ( name ) $newMap.datattr({name});
    if ( currentStyle ) $newMap.attr('style', currentStyle);

    $oldMap.replaceWith($newMap);
    return $newMap;
  }

  // [로직] 단일 지도 로드 및 마커 생성
  #loadMap($container) {
    if ( !this.#MapClass ) return;

    const $mapElement = this.#resetMapContainer($container);
    if ( !$mapElement ) return;

    const el = $mapElement[0];
    const lat = parseFloat(el.dataset.lat);
    const lng = parseFloat(el.dataset.lng);
    const name = el.dataset.name;

    if ( !lat || !lng || isNaN(lat) || isNaN(lng) ) return;

    const isDark = (typeof Darkmode !== 'undefined' && typeof Darkmode.is === 'function')
                 ? Darkmode.is() : false;
    const position = { lat, lng };

    const mapOptions = {
      zoom: 15,
      center: position,
      mapId: Locations.mapId,
      colorScheme: isDark ? 'DARK' : 'LIGHT',
      clickableIcons: false,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      keyboardShortcuts: false,
      rotateControl: false,
      zoomControl: true,
    };

    const map = new this.#MapClass(el, mapOptions);

    let markerContent = null;
    if ( isDark ) {
      const pinView = new this.#PinElement(Locations.config.pinDark);
      markerContent = pinView.element;
    }

    new this.#AdvancedMarkerElement({
      map: map,
      position: position,
      title: name,
      content: markerContent
    });

    this.#mapElements.push($mapElement);
  }

  // [로직] 화면 내 모든 지도 찾아서 렌더링
  #loadAllMaps() {
    this.#mapElements = [];
    const self = this;
    jQuery(ContactUs.selector).each(function() {
      self.#loadMap(jQuery(this));
    });
  }

  // [이벤트] 다크모드 변경 핸들러
  #handleDarkModeChange() {
    const currentElements = [...this.#mapElements];
    this.#mapElements = [];
    currentElements.forEach($el => this.#loadMap($el));
  }

  // [초기화] API 로드 및 옵저버 등록
  async watch() {
    let retry = 0;
    while (
      !window.google ||
      !window.google.maps ||
      typeof window.google.maps.importLibrary !== 'function'
    ) {
      if (retry > 50) return;
      await new Promise(r => setTimeout(r, 100));
      retry++;
    }

    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary('marker');

    this.#MapClass = Map;
    this.#AdvancedMarkerElement = AdvancedMarkerElement;
    this.#PinElement = PinElement;

    this.#loadAllMaps();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if ( mutation.attributeName === 'data-is-darkmode' ) {
          this.#handleDarkModeChange();
        }
      });
    });

    const targetNode = typeof root !== 'undefined' ? root : document.documentElement;
    observer.observe(targetNode, { attributes: true, attributeFilter: ['data-is-darkmode'] });
  }
}


export class HomeCover {
  constructor(selector = '[data-home-cover]') {
    this.selector = selector;
    this.intervalTime = 6000; // 6초 간격
  }

  // 🌟 프라이빗 초기화 및 루프 핸들러
  #init($cover) {
    // jQuery .data()는 유효한 JSON을 자동 파싱하므로 그대로 배열로 받습니다.
    const covers = $cover.data('homeCover') || [];

    if ( covers.length === 0 ) return;

    // jQuery를 활용한 DOM 요소 생성
    const $layer1 = jQuery('<div class="cover-layer is-active"></div>');
    const $layer2 = jQuery('<div class="cover-layer"></div>');

    $layer1.css('background-image', `url('${covers[0]}')`);

    // 부모 요소에 생성한 레이어 두 개를 한 번에 삽입
    $cover.append($layer1, $layer2);

    // 이미지가 2개 이상일 경우에만 루프 실행
    if ( covers.length > 1 ) {
      let currentIndex = 0;
      let activeLayer = 1;

      setInterval(() => {
        currentIndex = (currentIndex + 1) % covers.length;
        const nextImageUrl = `url('${covers[currentIndex]}')`;

        // 괄호 양끝 띄어쓰기 및 else 구문 줄바꿈 규칙 적용
        if ( activeLayer === 1 ) {
          $layer2.css('background-image', nextImageUrl).addClass('is-active');
          $layer1.removeClass('is-active');
          activeLayer = 2;
        }
        else {
          $layer1.css('background-image', nextImageUrl).addClass('is-active');
          $layer2.removeClass('is-active');
          activeLayer = 1;
        }
      }, this.intervalTime);
    }
  }

  // 🌟 공용 엔트리 포인트 (Public Method)
  watch() {
    const $covers = jQuery(this.selector);

    // 🌟 [수정] 직접 만드신 커스텀 익스텐션 .be('not')을 활용하여 우아하게 조기 종료
    if ( $covers.be('not') ) return;

    // 🌟 [수정] $.each 대신 컬렉션 메서드인 .each()를 사용하여 깔끔하게 순회
    $covers.each((_, elem) => this.#init(jQuery(elem)));
  }
}


export class HomeBanner {
  constructor(selector = '.home-banners') {
    this.selector = selector;
    this.intervalTime = 5000;
  }

  #init($container) {
    const $track = $container.find('.banner-track');
    const $slides = $track.find('.banner');
    const totalSlides = $slides.length;

    if ( totalSlides <= 1 ) return;

    const $prevBtn = $container.find('.banner-button.prev');
    const $nextBtn = $container.find('.banner-button.next');

    let currentIndex = 0;
    let slideInterval;

    // 🌟 최신 독립 CSS 속성인 translate를 사용하여 X축 이동
    const updateSlidePosition = () => {
      // Y축 이동은 없으므로 두 번째 값은 0으로 지정합니다.
      $track.css('translate', `-${currentIndex * 100}% 0`);
    };

    const nextSlide = () => {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlidePosition();
    };

    const prevSlide = () => {
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      updateSlidePosition();
    };

    const resetInterval = () => {
      clearInterval(slideInterval);
      slideInterval = setInterval(nextSlide, this.intervalTime);
    };

    if ( $nextBtn.length ) {
      $nextBtn.on('click', () => {
        nextSlide();
        resetInterval();
      });
    }

    if ( $prevBtn.length ) {
      $prevBtn.on('click', () => {
        prevSlide();
        resetInterval();
      });
    }

    slideInterval = setInterval(nextSlide, this.intervalTime);
  }

  watch() {
    const $banners = jQuery(this.selector);
    if ( $banners.be('not') ) return;
    $banners.each((_, elem) => this.#init(jQuery(elem)));
  }
}